window.CHEM_OVERRIDE_MAP = {
  "seamlock pro i-transparent white - dripless sl9825": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "transparent white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-white north - dripless sl9873": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "white north"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-cygnus pearl - dripless sl9864": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cygnus pearl"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-crystal clear - dripless sl9863": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "crystal clear"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-pure white - dripless sl9837": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "pure white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-baby's breath - dripless sl9959": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "baby's breath"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro anthracite - dripless sl9132": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "anthracite"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro pebble stone color adhesive cartridge - dripless sl9237": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "pebble"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro rhino stone color adhesive cartridge - dripless sl9238": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "rhino"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro sterling adhesive for countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sterling"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro sahara stone color adhesive cartridge - dripless sl9240": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sahara"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro bavarian cream - dripless sl9241": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "bavarian cream"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro timber wolf - dripless sl9259": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "timber wolf"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro veil adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "veil"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro burl white - dripless sl9265": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "burl white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro argento stone color adhesive cartridge - dripless sl9272": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "argento"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro industrial - dripless sl9280": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "industrial"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro steak red - dripless sl9453": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "steak red"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-tuscan white - dripless sl9559": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "tuscan white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro tower daybreak - dripless sl9572": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "daybreak"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "tower",
    "temp_range_f": "65-85"
  },
  "seamlock pro tower frosty white - dripless sl9574": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "frosty white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "tower",
    "temp_range_f": "65-85"
  },
  "seamlock pro tower nubuck - dripless sl9575": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "nubuck"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "tower",
    "temp_range_f": "65-85"
  },
  "seamlock pro tower onias - dripless sl9576": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "onias"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "tower",
    "temp_range_f": "65-85"
  },
  "seamlock pro tower vanilla - dripless sl9577": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "vanilla"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "tower",
    "temp_range_f": "65-85"
  },
  "seamlock pro tower vellum - dripless sl9578": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "vellum"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "tower",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-crystal white - dripless sl9584": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "crystal white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro raven stone color adhesive cartridge - dripless sl9645": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "raven"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro blanco stone color adhesive cartridge - dripless sl9646": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "blanco"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-wheat stone color adhesive cartridge - dripless sl9665": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "wheat"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-sand dollar - dripless sl9677": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sand dollar"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-alabaster - dripless sl9679": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "alabaster"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro mountain stone color adhesive cartridge - dripless sl9687": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "mountain"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro birch stone color adhesive cartridge - dripless sl9689": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "birch"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro clamshell - dripless sl9699": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "clamshell"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro bone pro stone color adhesive cartridge - dripless sl9705": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "bone pro"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-cocoa stone color adhesive cartridge - dripless sl9716": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cocoa"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-lunar stone color adhesive cartridge - dripless sl9751": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "lunar"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-weaping willow - dripless sl9758": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "weaping willow"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-lead stone color adhesive cartridge - dripless sl9761": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "lead"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-coffee stone color adhesive cartridge - dripless sl9762": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "coffee"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-wool stone color adhesive cartridge - dripless sl9763": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "wool"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-lily white - dripless sl9768": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "lily white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-sabbia stone color adhesive cartridge - dripless sl9772": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sabbia"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-sand stone color adhesive cartridge - dripless sl9331": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sand"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-pumice stone color adhesive cartridge - dripless sl9777": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "pumice"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-warm grey - dripless sl9806": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "warm grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-river rock - dripless sl9807": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "river rock"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-suede stone color adhesive cartridge - dripless sl9898": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "suede"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-dove stone color adhesive cartridge - dripless sl9915": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "dove"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-cedar stone color adhesive cartridge - dripless sl9916": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cedar"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-bisquit - dripless sl9919": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "bisquit"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro hadley stone color adhesive cartridge - dripless sl9930": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "hadley"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro c neutral - dripless sl9943": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "c neutral"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-polar stone color adhesive cartridge - dripless sl9945": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "polar"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro silverite - dripless sl9950": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "silverite"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-onyx stone color adhesive cartridge - dripless sl9953": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "onyx"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-midnight - dripless sl9954": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "midnight"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-raven stone color adhesive cartridge - dripless sl9955": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "raven"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-balsa stone color adhesive cartridge - dripless sl9958": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "balsa"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro nantucket - dripless sl9960": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "nantucket"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-ash stone color adhesive cartridge - dripless sl9961": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "ash"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro uliano adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "uliano"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro messina stone color adhesive cartridge - dripless sl9993": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "messina"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro salo stone color adhesive cartridge - dripless sl9995": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "salo"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro winter adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "winter"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro bright stone color adhesive cartridge - dripless sl9102": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "bright"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro brilliant - dripless sl9103": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "brilliant"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro cotton stone color adhesive cartridge - dripless sl9104": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cotton"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro vanilla adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "vanilla"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro marble stone color adhesive cartridge - dripless sl9106": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "marble"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro porcelain - dripless sl9107": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "porcelain"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro snow adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "snow"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro antique stone seam adhesive -- dripless sl9109": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "antique stone seam"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro satin stone color adhesive cartridge - dripless sl9110": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "satin"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro glacier stone color adhesive cartridge - dripless sl9111": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "glacier"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro canvas stone color adhesive cartridge - dripless sl9112": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "canvas"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro blizzard stone color adhesive cartridge - dripless sl9113": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "blizzard"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro opal stone color adhesive cartridge - dripless sl9114": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "opal"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro ghost stone color adhesive cartridge - dripless sl9115": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "ghost"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro newport stone color adhesive cartridge - dripless sl9116": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "newport"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro designer white - dripless sl9117": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "designer white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro cloud stone color adhesive cartridge - dripless sl9118": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cloud"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro white adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro cameo stone color adhesive cartridge - dripless sl9120": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cameo"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro arctic stone color adhesive cartridge - dripless sl9121": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "arctic"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro inf8701 stone color adhesive cartridge - dripless sl9122": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "inf8701"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro sterling white - dripless sl9125": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sterling white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro clear stone color adhesive cartridge - dripless sl9199": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "clear"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro fog stone color adhesive cartridge - dripless sl9200": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "fog"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro buff stone color adhesive cartridge - dripless sl9210": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "buff"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro natural stone color adhesive cartridge - dripless sl9214": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "natural"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro sand stone color adhesive cartridge - dripless sl9216": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sand"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro ice stone color adhesive cartridge - dripless sl9218": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "ice"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro misty stone color adhesive cartridge - dripless sl9220": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "misty"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro stone adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "stone"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro blonde stone color adhesive cartridge - dripless sl9225": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "blonde"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro butter stone color adhesive cartridge - dripless sl9226": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "butter"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro beach stone color adhesive cartridge - dripless sl9230": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "beach"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro manilla stone color adhesive cartridge - dripless sl9231": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "manilla"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro cream stone color adhesive cartridge - dripless sl9232": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cream"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro caramel stone color adhesive cartridge - dripless sl9234": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "caramel"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro torano adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "torano"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro khaki stone color adhesive cartridge - dripless sl9236": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "khaki"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro warm nature - dripless sl9277": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "warm nature"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro grey nature - dripless sl9278": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "grey nature"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro redfire stone color adhesive cartridge - dripless sl9279": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "redfire"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro serene stone color adhesive cartridge - dripless sl9304": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "serene"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro dune stone color adhesive cartridge - dripless sl9310": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "dune"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro latte stone color adhesive cartridge - dripless sl9312": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "latte"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro willow adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "willow"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro fawn stone color adhesive cartridge - dripless sl9316": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "fawn"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro sonora adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sonora"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro toffee adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "toffee"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro mocha stone color adhesive cartridge - dripless sl9322": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "mocha"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro cocoa stone color adhesive cartridge - dripless sl9323": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cocoa"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro chocolate - dripless sl9324": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "chocolate"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro suede adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "suede"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro auburn stone color adhesive cartridge - dripless sl9330": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "auburn"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro roast stone color adhesive cartridge - dripless sl9332": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "roast"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro sunshine adhesive for countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sunshine"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro orange zest - dripless sl9415": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "orange zest"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro copper stone color adhesive cartridge - dripless sl9418": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "copper"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro rust stone color adhesive cartridge - dripless sl9424": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "rust"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro hazel stone color adhesive cartridge - dripless sl9432": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "hazel"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro fuego stone color adhesive cartridge - dripless sl9450": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "fuego"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro red stone color adhesive cartridge - dripless sl9451": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "red"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro red lava stone color adhesive cartridge - dripless sl9452": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "red lava"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro universe adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "universe"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro skye adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "skye"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro elbert stone color adhesive cartridge - dripless sl9505": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "elbert"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro urban grey - dripless sl9506": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "urban grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro splendor gray - dripless sl9507": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "splendor gray"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro titanium grey - dripless sl9508": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "titanium grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro dove shimmer - dripless sl9509": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "dove shimmer"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro pearl stone color adhesive cartridge - dripless sl9510": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "pearl"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro archer grey - dripless sl9511": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "archer grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro slate adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "slate"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro gray s005 - dripless sl9513": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "gray s005"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro ore stone color adhesive cartridge - dripless sl9515": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "ore"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro prairie stone color adhesive cartridge - dripless sl9516": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "prairie"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro concrete gray - dripless sl9517": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "concrete gray"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro pewter stone color adhesive cartridge - dripless sl9518": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "pewter"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro mist gray - dripless sl9519": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "mist gray"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro olive stone color adhesive cartridge - dripless sl9520": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "olive"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro lava stone color adhesive cartridge - dripless sl9521": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "lava"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro thunder adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "thunder"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro smoke adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "smoke"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro deep cloud - dripless sl9524": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "deep cloud"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro shale adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "shale"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro clay stone color adhesive cartridge - dripless sl9526": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "clay"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro new concrete - dripless sl9527": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "new concrete"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro espresso stone color adhesive cartridge - dripless sl9528": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "espresso"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro oyster stone color adhesive cartridge - dripless sl9529": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "oyster"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro coal stone color adhesive cartridge - dripless sl9530": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "coal"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro sable stone color adhesive cartridge - dripless sl9531": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sable"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro midnight stone color adhesive cartridge - dripless sl9532": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "midnight"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro titanium adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "titanium"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro pitch stone color adhesive cartridge - dripless sl9534": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "pitch"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-snow white - dripless sl9537": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "snow white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro tornado gray - dripless sl9538": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "tornado gray"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-sandstone - dripless sl9539": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sandstone"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro antique blue - dripless sl9540": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "antique blue"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro placid stone color adhesive cartridge - dripless sl9541": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "placid"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-fieldstone - dripless sl9776": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "fieldstone"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro green stone color adhesive cartridge - dripless sl9560": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "green"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro cherry pink - dripless sl9561": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cherry pink"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro horizon haze - dripless sl9562": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "horizon haze"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro tower bisque - dripless sl9570": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "bisque"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "tower",
    "temp_range_f": "65-85"
  },
  "seamlock pro tower bone - dripless sl9571": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "bone"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "tower",
    "temp_range_f": "65-85"
  },
  "seamlock pro tower designer white - dripless sl9573": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "designer white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "tower",
    "temp_range_f": "65-85"
  },
  "seamlock pro nova stone color adhesive cartridge - dripless sl9582": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "nova"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro design stone color adhesive cartridge - dripless sl9601": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "design"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro frosty stone color adhesive cartridge - dripless sl9603": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "frosty"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro mesa stone color adhesive cartridge - dripless sl9604": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "mesa"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro umber adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "umber"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro pudding stone color adhesive cartridge - dripless sl9606": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "pudding"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro adobe stone seam adhesive -- dripless sl9608": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "adobe stone seam"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro camel stone color adhesive cartridge - dripless sl9610": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "camel"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro sun color adhesive for countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sun color"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro hot stone color adhesive cartridge - dripless sl9617": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "hot"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro mandarin stone color adhesive cartridge - dripless sl9619": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "mandarin"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro fire stone color adhesive cartridge - dripless sl9621": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "fire"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro silver adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "silver"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro ash stone color adhesive cartridge - dripless sl9623": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "ash"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro malt stone color adhesive cartridge - dripless sl9624": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "malt"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro charcoal stone color adhesive cartridge - dripless sl9625": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "charcoal"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro flax stone color adhesive cartridge - dripless sl9627": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "flax"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro earth stone color adhesive cartridge - dripless sl9628": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "earth"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro lime stone color adhesive cartridge - dripless sl9632": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "lime"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro orange stone color adhesive cartridge - dripless sl9633": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "orange"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro nutmeg stone color adhesive cartridge - dripless sl9635": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "nutmeg"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro oregano stone color adhesive cartridge - dripless sl9636": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "oregano"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro ecru stone color adhesive cartridge - dripless sl9637": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "ecru"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro nickel stone color adhesive cartridge - dripless sl9638": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "nickel"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro chai stone color adhesive cartridge - dripless sl9639": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "chai"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro riverstone - dripless sl9641": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "riverstone"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro aluminum stone seam adhesive -- dripless sl9642": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "aluminum stone seam"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro coffee stone color adhesive cartridge - dripless sl9643": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "coffee"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro chestnut stone color adhesive cartridge - dripless sl9644": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "chestnut"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro moss stone color adhesive cartridge - dripless sl9647": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "moss"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro toscana adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "toscana"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro meridian stone color adhesive cartridge - dripless sl9649": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "meridian"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro banana stone color adhesive cartridge - dripless sl9650": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "banana"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro bala blue - dripless sl9652": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "bala blue"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro dover stone color adhesive cartridge - dripless sl9653": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "dover"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro devon stone color adhesive cartridge - dripless sl9654": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "devon"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro whisper adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "whisper"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro silt adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "silt"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro laguna stone color adhesive cartridge - dripless sl9658": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "laguna"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro cherry stone color adhesive cartridge - dripless sl9662": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cherry"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro honeydew stone color adhesive cartridge - dripless sl9663": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "honeydew"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro pomegranite - dripless sl9666": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "pomegranite"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro rossa stone color adhesive cartridge - dripless sl9667": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "rossa"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro wood adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "wood"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro delfino stone color adhesive cartridge - dripless sl9671": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "delfino"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro shell adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "shell"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro clam stone color adhesive cartridge - dripless sl9673": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "clam"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro mojave stone color adhesive cartridge - dripless sl9674": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "mojave"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro danae stone color adhesive cartridge - dripless sl9675": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "danae"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro leather stone color adhesive cartridge - dripless sl9678": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "leather"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro marta stone color adhesive cartridge - dripless sl9680": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "marta"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro flannel stone color adhesive cartridge - dripless sl9682": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "flannel"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro sand storm - dripless sl9683": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sand storm"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro botticino - dripless sl9684": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "botticino"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro happy red - dripless sl9691": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "happy red"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro hemp stone color adhesive cartridge - dripless sl9692": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "hemp"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro crimson stone color adhesive cartridge - dripless sl9693": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "crimson"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro tierra adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "tierra"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro battleship - dripless sl9718": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "battleship"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro conche stone color adhesive cartridge - dripless sl9719": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "conche"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro naranja stone color adhesive cartridge - dripless sl9729": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "naranja"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro bronze stone color adhesive cartridge - dripless sl9731": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "bronze"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro sandshire - dripless sl9732": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sandshire"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro sussex adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sussex"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro reading stone color adhesive cartridge - dripless sl9735": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "reading"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro brownie stone color adhesive cartridge - dripless sl9736": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "brownie"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro shadow adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "shadow"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro celestial - dripless sl9739": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "celestial"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-trufa stone color adhesive cartridge - dripless sl9742": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "trufa"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-glacier white - dripless sl9747": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "glacier white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-bisque stone color adhesive cartridge - dripless sl9748": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "bisque"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro butternut - dripless sl9752": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "butternut"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro vicenza adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "vicenza"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro tempest adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "tempest"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-marone stone color adhesive cartridge - dripless sl9766": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "marone"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-cotton stone color adhesive cartridge - dripless sl9770": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cotton"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-raton stone color adhesive cartridge - dripless sl9774": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "raton"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-nacreto - dripless sl9778": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "nacreto"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-arctic white - dripless sl9780": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "arctic white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-cinder stone color adhesive cartridge - dripless sl9781": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cinder"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-ginger stone color adhesive cartridge - dripless sl9782": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "ginger"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-graphite - dripless sl9783": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "graphite"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-medea stone color adhesive cartridge - dripless sl9784": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "medea"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-polar white - dripless sl9785": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "polar white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-white linen - dripless sl9786": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "white linen"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-winter white - dripless sl9787": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "winter white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-champagne - dripless sl9788": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "champagne"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-cinnamon spice - dripless sl9789": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cinnamon spice"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-giallo stone color adhesive cartridge - dripless sl9792": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "giallo"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-iron grey - dripless sl9794": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "iron grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-natural almond - dripless sl9795": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "natural almond"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-natural grey - dripless sl9796": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "natural grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-nougat stone color adhesive cartridge - dripless sl9797": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "nougat"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-seashell - dripless sl9798": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "seashell"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-tan stone color adhesive cartridge - dripless sl9799": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "tan"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-chameleon - dripless sl9800": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "chameleon"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-casper stone color adhesive cartridge - dripless sl9801": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "casper"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-dawn stone color adhesive cartridge - dripless sl9802": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "dawn"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-taupe stone color adhesive cartridge - dripless sl9803": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "taupe"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-boulder - dripless sl9810": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "boulder"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-flint stone color adhesive cartridge - dripless sl9811": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "flint"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-white chocolate - dripless sl9813": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "white chocolate"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-pewter stone color adhesive cartridge - dripless sl9814": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "pewter"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-pearl grey - dripless sl9815": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "pearl grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-bone stone color adhesive cartridge - dripless sl9816": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "bone"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-cocoa brown - dripless sl9818": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cocoa brown"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-slate stone color adhesive cartridge - dripless sl9819": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "slate"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-earth brown - dripless sl9820": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "earth brown"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-sage stone color adhesive cartridge - dripless sl9821": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sage"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-bright white - dripless sl9822": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "bright white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-charcoal - dripless sl9823": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "charcoal"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-butterscotch - dripless sl9824": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "butterscotch"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-magic stone color adhesive cartridge - dripless sl9826": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "magic"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-satin black - dripless sl9827": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "satin black"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-khaki stone color adhesive cartridge - dripless sl9828": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "khaki"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-acorn stone color adhesive cartridge - dripless sl9829": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "acorn"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-toffee stone color adhesive cartridge - dripless sl9830": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "toffee"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-aqueous - dripless sl9831": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "aqueous"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-ash stone color adhesive cartridge - dripless sl9832": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "ash"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-autumn light - dripless sl9833": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "autumn light"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-beach stone color adhesive cartridge - dripless sl9834": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "beach"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-cambrian gold - dripless sl9835": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cambrian gold"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-desert stone color adhesive cartridge - dripless sl9836": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "desert"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-espresso - dripless sl9838": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "espresso"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-lunar pearl - dripless sl9842": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "lunar pearl"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-natural - dripless sl9844": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "natural"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-pearl stone color adhesive cartridge - dripless sl9845": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "pearl"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-pudding brown - dripless sl9846": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "pudding brown"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-rambone - dripless sl9847": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "rambone"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-rhin stone color adhesive cartridge - dripless sl9848": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "rhin"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro oat stone color adhesive cartridge - dripless sl9850": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "oat"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-silver stone color adhesive cartridge - dripless sl9851": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "silver"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-storm grey - dripless sl9852": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "storm grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-thunder grey - dripless sl9853": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "thunder grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-tidal sand - dripless sl9854": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "tidal sand"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-tusk stone color adhesive cartridge - dripless sl9855": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "tusk"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-uba tuba - dripless sl9856": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "uba tuba"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-transparent black - dripless sl9857": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "transparent black"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-aztec gold - dripless sl9858": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "aztec gold"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-amarillo - dripless sl9861": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "amarillo"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-coffee stone color adhesive cartridge - dripless sl9862": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "coffee"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-dusk stone color adhesive cartridge - dripless sl9865": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "dusk"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-mocha stone color adhesive cartridge - dripless sl9867": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "mocha"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-neutral - dripless sl9868": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "neutral"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-newport grey - dripless sl9869": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "newport grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-stellar grey - dripless sl9871": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "stellar grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-white stone color adhesive cartridge - dripless sl9872": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-absolute grey - dripless sl9874": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "absolute grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-alabaster - dripless sl9875": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "alabaster"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-amazon stone color adhesive cartridge - dripless sl9876": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "amazon"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-beige olimpo - dripless sl9878": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "beige olimpo"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-black stone color adhesive cartridge - dripless sl9879": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "black"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-brazilian brown - dripless sl9881": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "brazilian brown"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-brie stone color adhesive cartridge - dripless sl9882": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "brie"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-cloud stone color adhesive cartridge - dripless sl9883": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "cloud"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-concrete - dripless sl9884": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "concrete"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-diana pearl - dripless sl9885": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "diana pearl"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-galaxy black - dripless sl9886": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "galaxy black"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-jet black - dripless sl9887": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "jet black"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-limestone - dripless sl9888": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "limestone"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-mercury grey - dripless sl9889": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "mercury grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-meteor grey - dripless sl9890": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "meteor grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-newgale grey - dripless sl9891": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "newgale grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-onyx stone color adhesive cartridge - dripless sl9892": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "onyx"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-oyster stone color adhesive cartridge - dripless sl9893": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "oyster"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-perfect white - dripless sl9894": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "perfect white"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-sahara stone color adhesive cartridge - dripless sl9895": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "sahara"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-vega rose - dripless sl9896": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "vega rose"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-zenith stone color adhesive cartridge - dripless sl9897": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "zenith"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-vela brown - dripless sl9899": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "vela brown"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-quarry stone color adhesive cartridge - dripless sl9900": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "quarry"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro brume stone color adhesive cartridge - dripless sl9904": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "brume"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro jungle stone color adhesive cartridge - dripless sl9905": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "jungle"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro mango stone color adhesive cartridge - dripless sl9906": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "mango"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro apple stone seam adhesive -- dripless sl9907": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "apple stone seam"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro putty stone color adhesive cartridge - dripless sl9908": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "putty"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro blue stone color adhesive cartridge - dripless sl9909": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "blue"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro vino adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "vino"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro azul stone color adhesive cartridge - dripless sl9911": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "azul"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro carbon stone color adhesive cartridge - dripless sl9912": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "carbon"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro rain stone color adhesive cartridge - dripless sl9913": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "rain"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro grey stone color adhesive cartridge - dripless sl9917": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro rouge stone color adhesive cartridge - dripless sl9920": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "rouge"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro gris stone color adhesive cartridge - dripless sl9925": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "gris"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro tan color adhesive for countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "tan color"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro tawny adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "tawny"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro pink stone color adhesive cartridge - dripless sl9931": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "pink"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro fossil stone color adhesive cartridge - dripless sl9946": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "fossil"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-steel grey - dripless sl9947": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "steel grey"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro pea stone color adhesive cartridge - dripless sl9951": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "pea"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro emperador - dripless sl9966": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "emperador"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro paprika stone color adhesive cartridge - dripless sl9967": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "paprika"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro coral stone color adhesive cartridge - dripless sl9977": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "coral"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro nirvana stone color adhesive cartridge - dripless sl9978": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "nirvana"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro moose stone color adhesive cartridge - dripless sl9979": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "moose"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro bourbon stone color adhesive cartridge - dripless sl9985": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "bourbon"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro bento stone color adhesive cartridge - dripless sl9986": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "bento"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro mystic gray - dripless sl9988": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "mystic gray"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro marmi stone color adhesive cartridge - dripless sl9989": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "marmi"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro dark roast - dripless sl9990": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "dark roast"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "big dog seamlock pro wax adhesive for stone countertop seaming": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "wax"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "standard",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-crystal clear - dripless sl9999": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "crystal clear"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro p-slate stone color adhesive cartridge - dripless sl9760": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "slate"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "p-series",
    "temp_range_f": "65-85"
  },
  "seamlock pro i-oxford brown - dripless sl9476": {
    "type": "adhesive",
    "subtype": "Methacrylate",
    "vendor": "Big Dog Adhesives",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "glass",
      "granite",
      "sintered",
      "quartz",
      "solid surface",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Dripless Cartridge",
    "colors": [
      "oxford brown"
    ],
    "warnings": [
      "Flammable.",
      "Skin irritant.",
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "disc": false,
    "mix_ratio": "10:1",
    "work_time": "8-12",
    "cure_time": "20-25",
    "uv_stable": true,
    "series": "i-series",
    "temp_range_f": "65-85"
  },
  "tenax colored knife grade polyester - professional grade": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "fissures",
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "multiple pre-colored options"
    ],
    "warnings": [
      "Interior only - not UV stable.",
      "Requires Tenax hardener.",
      "Available in multiple pre-tinted colors.",
      "May yellow on light-colored marble over time.",
      "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead."
    ],
    "disc": false,
    "mix_ratio": "100:2-3 (resin to hardener by weight)",
    "work_time": "4-6 min",
    "cure_time": "20-30 min"
  },
  "tenax titanium transparent knife grade vinylester glue - 1 gallon": {
    "type": "adhesive",
    "subtype": "Vinyl-Ester",
    "vendor": "Tenax",
    "env": [
      "exterior",
      "interior"
    ],
    "app": [
      "rodding",
      "fissures",
      "mitering",
      "seaming",
      "laminating",
      "repair"
    ],
    "mat": [
      "engineered",
      "marble",
      "granite",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Low yellowing but formulated for UV resistance.",
      "Store between 68-77F.",
      "12-month shelf life.",
      "1 gallon size."
    ],
    "disc": false,
    "mix_ratio": "100:2-3 (resin to catalyst by weight)",
    "work_time": "4-5 min (gel time)",
    "cure_time": "15 min"
  },
  "tenax strong edge professional stone adhesive system": {
    "type": "adhesive",
    "subtype": "Epoxy",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "rodding",
      "seaming",
      "mitering",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "granite",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "water clear (colorable)"
    ],
    "warnings": [
      "Strongest clear knife-grade epoxy in Tenax line.",
      "Polishable.",
      "Does not shrink.",
      "Prevents delamination.",
      "Long cure time compared to polyester adhesives."
    ],
    "disc": false,
    "mix_ratio": "2:1",
    "work_time": "30-60 min",
    "cure_time": "~45 min at 75F"
  },
  "tenax domo epoxy adhesive for stone fabrication": {
    "type": "adhesive",
    "subtype": "Epoxy",
    "vendor": "Tenax",
    "env": [
      "exterior",
      "interior"
    ],
    "app": [
      "rodding",
      "anchoring",
      "substrate-bonding",
      "seaming",
      "laminating",
      "repair"
    ],
    "mat": [
      "engineered",
      "marble",
      "concrete",
      "granite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "white (colorable with Tenax Universal Colors)"
    ],
    "warnings": [
      "Colors easily with Tenax pigments.",
      "Bonds to polished and damp surfaces.",
      "VOC compliant.",
      "2-year shelf life at 65-77F.",
      "Long cure time compared to polyester adhesives."
    ],
    "disc": false,
    "mix_ratio": "1:1",
    "work_time": "~2.5 hours (gel time at 77F)",
    "cure_time": "24 hours (full cure); tack-free ~4 hours"
  },
  "tenax multibond acrylic cartridge adhesive 250 ml - styrene-free color match for stone": {
    "type": "adhesive",
    "subtype": "Acrylic (Methacrylate)",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "seaming",
      "laminating",
      "repair"
    ],
    "mat": [
      "engineered",
      "marble",
      "granite",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "bond-failure"
    ],
    "viscosity": "Gel",
    "colors": [
      "multiple color-matched options"
    ],
    "warnings": [
      "Styrene-free formula.",
      "Dripless - suitable for vertical surfaces.",
      "Requires Tenax 10:1 cartridge gun.",
      "Super flexible."
    ],
    "disc": false,
    "mix_ratio": "10:1 (pre-dosed cartridge)",
    "work_time": "8-12 min",
    "cure_time": "20-30 min"
  },
  "tenax transparent flowing polyester adhesive big box (4 x 1.25 gallon)": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "fissures",
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "quartzite",
      "marble",
      "granite"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Flowing",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Interior only - not UV stable.",
      "Horizontal application only due to flowing consistency.",
      "Big box: 4 x 1.25 gallon.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work.",
      "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead."
    ],
    "disc": false,
    "mix_ratio": "100:2-3 (resin to hardener by weight)",
    "work_time": "4-6 min",
    "cure_time": "20-30 min"
  },
  "tenax vertigo s colorless knife grade vinyl ester big box (4 x 1.25 gallon)": {
    "type": "adhesive",
    "subtype": "Vinyl-Ester",
    "vendor": "Tenax",
    "env": [
      "exterior",
      "interior"
    ],
    "app": [
      "rodding",
      "fissures",
      "mitering",
      "seaming",
      "laminating",
      "repair"
    ],
    "mat": [
      "engineered",
      "marble",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "water clear"
    ],
    "warnings": [
      "Low yellowing - formulated for UV resistance.",
      "Drip-less formula.",
      "Big box: 4 x 1.25 gallon."
    ],
    "disc": false,
    "mix_ratio": "100:2-3 (resin to catalyst by weight)",
    "work_time": "4-5 min (gel time)",
    "cure_time": "25 min"
  },
  "tixo ex transparent knife grade adhesive 17 kg": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "fissures",
      "repair"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Interior only - not UV stable.",
      "17 kg bulk pail.",
      "May yellow on light-colored marble over time.",
      "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead.",
      "Tixo is a repair and fissure-fill product. NOT for structural seaming or lamination."
    ],
    "disc": false,
    "mix_ratio": "100:2-3 (resin to hardener by weight)",
    "work_time": "4-6 min",
    "cure_time": "20-30 min"
  },
  "tenax flowing titanium vinyl ester adhesive for granite and marble lamination": {
    "type": "adhesive",
    "subtype": "Vinyl-Ester",
    "vendor": "Tenax",
    "env": [
      "exterior",
      "interior"
    ],
    "app": [
      "rodding",
      "fissures",
      "seaming",
      "laminating",
      "repair"
    ],
    "mat": [
      "quartzite",
      "marble",
      "granite",
      "engineered"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Flowing",
    "colors": [
      "extra clear (slight blue-purple tint)"
    ],
    "warnings": [
      "Low yellowing - formulated for UV resistance.",
      "Store between 68-77F.",
      "12-month shelf life.",
      "Horizontal application only.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "100:2-3 (resin to catalyst by weight)",
    "work_time": "4-5 min (gel time)",
    "cure_time": "15 min"
  },
  "tenax glaxs bb 65 epoxy adhesive for stone fabrication": {
    "type": "adhesive",
    "subtype": "Acrylic-Resin",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "fissures",
      "repair",
      "laminating"
    ],
    "mat": [
      "quartzite",
      "marble",
      "granite",
      "engineered"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Flowing",
    "colors": [
      "water clear"
    ],
    "warnings": [
      "Zero yellowing - UV stable.",
      "Zero VOC.",
      "Cures at any temperature including 0C.",
      "Ideal for white marble and porous stone.",
      "1-year shelf life at 65-77F.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "100:65",
    "work_time": "8-12 min",
    "cure_time": "~20-25 min"
  },
  "proseal nano premium grade quartzite stone sealer": {
    "type": "sealer",
    "subtype": "Penetrating Impregnator With Nanotechnology, Solvent-Based",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "quartzite",
      "engineered",
      "granite",
      "concrete"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Solvent-based.",
      "Works on polished, honed, sandblasted, flamed finishes.",
      "Incompatible with acids, bases, strong oxidants, aluminium, plastics.",
      "Does not alter natural breathability."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "problems": [
      "water-damage"
    ]
  },
  "tenax hydrex natural effect sealer for natural and engineered stone": {
    "type": "sealer",
    "subtype": "Penetrating Impregnator, Solvent-Based, Natural Effect",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "quartzite",
      "marble",
      "granite",
      "engineered"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Does NOT change stone color - natural effect.",
      "Water and oil proof.",
      "Does NOT provide anti-etch protection on marble.",
      "Coverage: 215-323 sq ft per liter.",
      "2-year shelf life at 65-77F."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "24 hours full protection"
  },
  "stain rescue remover ( formerly known as tenax quartz extraclean pro ) 1 qt": {
    "type": "stain-remover",
    "subtype": "Solvent-Based Cleaner For Engineered Stone",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "engineered"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Designed to remove greasy suction cup rings from quartz slabs.",
      "Apply with cloth, leave 1-2 minutes, rub in circular motion.",
      "Coverage: 200-300 sq ft per quart."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax cera pasta clear wax paste (1 liter / 1 quart)": {
    "type": "wax",
    "subtype": "Paste Wax For Stone Finishing",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "mat": [
      "marble",
      "granite",
      "engineered",
      "travertine"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Paste",
    "colors": [
      "clear"
    ],
    "warnings": [
      "Increases polish and eliminates superficial defects.",
      "Accents stone color.",
      "For onyxes, marbles, agglomerates, and terrazzo."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "app": [
      "enhancing"
    ]
  },
  "tenax teclean stain remover 8 oz for stone surface restoration": {
    "type": "stain-remover",
    "subtype": "Poultice Powder Stain Remover",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "concrete",
      "engineered",
      "travertine"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Poultice powder format - mix with water to form paste.",
      "Apply to stain, cover, let dry, then remove."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax skudo shield - quartz shield - 1 l": {
    "type": "sealer",
    "subtype": "Penetrating Impregnator, Water-Based, Natural Effect",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "quartzite",
      "engineered",
      "granite",
      "porcelain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Water-based formula.",
      "Food contact approved (EC Reg 1935/2004).",
      "Repels oil and water.",
      "Safe for quartz and engineered stone.",
      "Does not form surface films."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "problems": [
      "water-damage"
    ]
  },
  "tenax cera black g liquid wax for black granite": {
    "type": "wax",
    "subtype": "Liquid Wax For Dark Stone Maintenance",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "mat": [
      "granite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [
      "black"
    ],
    "warnings": [
      "Specifically designed for black granite.",
      "Increases black effect without increasing gloss.",
      "Also known as Uniblack 2.",
      "Use after Toner Black for complete black restoration system.",
      "2-year shelf life at 65-77F."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "app": [
      "enhancing"
    ]
  },
  "tenax terust rust remover powder for stone and marble cleaning": {
    "type": "stain-remover",
    "subtype": "Rust Remover Powder",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "concrete",
      "engineered",
      "travertine"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Powder format - mix with water.",
      "Specifically for rust stain removal from stone."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax hydrex natural effect stone sealer for granite and marble": {
    "type": "sealer",
    "subtype": "Penetrating Impregnator, Solvent-Based, Natural Effect",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "quartzite",
      "marble",
      "granite",
      "engineered"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Does NOT change stone color - natural effect.",
      "Water and oil proof.",
      "Does NOT provide anti-etch protection on marble.",
      "Coverage: 215-323 sq ft per liter.",
      "2-year shelf life at 65-77F."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "24 hours full protection"
  },
  "tenax ager stone color enhancing sealer 1 quart": {
    "type": "enhancer",
    "subtype": "Penetrating Color Enhancer With Sealing, Solvent-Based",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "engineered",
      "concrete",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Does NOT provide anti-etch protection on marble.",
      "UV resistant, non-yellowing.",
      "Wait 24 hours for finished surface.",
      "No foot traffic for 4-6 hours after treatment.",
      "1 quart size.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true
  },
  "tenax ager tiger 1qt. (1l) exotic stone enhancer & sealer for granite - color enriching, stain protection": {
    "type": "enhancer",
    "subtype": "Penetrating Color Enhancer With Sealing, Solvent-Based, For Exotic Stone",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "concrete",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Designed for exotic stones - darkens and enriches color.",
      "Does NOT provide anti-etch protection on marble.",
      "UV resistant, non-yellowing.",
      "Drying time ~1 hour.",
      "Wait 24 hours before foot traffic.",
      "Coverage: 140-323 sq ft per liter depending on porosity."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "24 hours water repellent",
    "not_for_restoration": true
  },
  "tenax booster alk easy alkaline stone treatment - 750 ml": {
    "type": "stain-remover",
    "subtype": "Ready-To-Use Alkaline Spray Cleaner/Degreaser",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "engineered",
      "concrete",
      "granite",
      "porcelain"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Do not dilute - use as-is.",
      "Maximum contact time: 30 minutes.",
      "Removes organic stains, wax residue, food stains.",
      "May affect alkali-sensitive surfaces.",
      "750 ml spray bottle."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax wax remover for natural stone surfaces - 1 quart": {
    "type": "cleaner",
    "subtype": "Solvent-Based Wax Remover",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "engineered"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Removes paste and liquid wax residue from stone surfaces.",
      "Solvent-based."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax stain rescue remover 250 ml for granite and marble care": {
    "type": "stain-remover",
    "subtype": "Solvent-Based Cleaner For Engineered Stone",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "engineered"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Designed to remove greasy suction cup rings from quartz slabs.",
      "Apply with cloth, leave 1-2 minutes, rub in circular motion.",
      "250 ml size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax ager tiger exotic stone sealer 250 ml": {
    "type": "enhancer",
    "subtype": "Penetrating Color Enhancer With Sealing, Solvent-Based, For Exotic Stone",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "concrete",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Designed for exotic stones - darkens and enriches color.",
      "Does NOT provide anti-etch protection on marble.",
      "UV resistant, non-yellowing.",
      "250 ml size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "24 hours water repellent",
    "not_for_restoration": true
  },
  "tenax ager fs water-based sealer 250 ml food safe": {
    "type": "enhancer",
    "subtype": "Water-Based Color Enhancer With Sealing, Food-Safe Certified",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "engineered",
      "concrete",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Food contact approved (EC Reg 90/128 ECC).",
      "Water-based - lower VOC.",
      "Conceals small scratches on engineered stone.",
      "UV stable - does not change color in sunlight.",
      "250 ml size.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true
  },
  "tenax luxor spray 0.5 liter aerosol varnish": {
    "type": "polish",
    "subtype": "Aerosol Self-Polishing Varnish Spray",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "marble",
      "granite",
      "engineered",
      "travertine"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Forms hard anti-scratch film on surface.",
      "UV stable - does not yellow.",
      "Excellent for chiseled edges and underside of overhangs.",
      "Aerosol spray format - 0.5 liter."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax rust remover liquid 1 liter for natural stone surfaces": {
    "type": "stain-remover",
    "subtype": "Liquid Rust Remover For Stone",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "concrete",
      "engineered",
      "travertine"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Specifically for rust stain removal from stone.",
      "1 liter liquid format."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax lustro italiano reseal kit for natural stone surfaces": {
    "type": "sealer",
    "subtype": "Consumer Stone Resealing Kit",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "marble",
      "granite",
      "engineered"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Part of Lustro Italiano consumer stone care line.",
      "Kit includes sealer and application materials."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "problems": [
      "water-damage"
    ]
  },
  "tenax lustro italiano quartz stone sealer 16 fl oz": {
    "type": "sealer",
    "subtype": "Penetrating Impregnator For Engineered Stone",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "engineered"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Designed specifically for quartz and engineered stone.",
      "Part of Lustro Italiano consumer line.",
      "16 fl oz size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "problems": [
      "water-damage"
    ]
  },
  "tenax lustro italiano stain remover poultice powder 8 oz": {
    "type": "stain-remover",
    "subtype": "Poultice Powder Stain Remover",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "concrete",
      "engineered",
      "travertine"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Poultice powder format - mix with water to form paste.",
      "Part of Lustro Italiano consumer line.",
      "8 oz size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax concrete prowax 1 liter - protective polymer coating for cement surfaces": {
    "type": "sealer",
    "subtype": "Protective Polymer Coating For Cement",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "concrete"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Polymer blend creates protective film in pores.",
      "For cement and cement agglomerates.",
      "Protects from organic and inorganic substances."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "problems": [
      "water-damage"
    ]
  },
  "tenax cera fluida liquid stone wax 1 quart for marble & granite": {
    "type": "wax",
    "subtype": "Liquid Wax For Stone Finishing",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "mat": [
      "marble",
      "granite",
      "engineered",
      "travertine"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [
      "clear"
    ],
    "warnings": [
      "Increases polish and eliminates superficial defects on marble.",
      "Accents stone color.",
      "For onyxes, marbles, agglomerates, and terrazzo."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "app": [
      "enhancing"
    ]
  },
  "ager - the original color enhancer impregnataor sealer": {
    "type": "enhancer",
    "subtype": "Penetrating Color Enhancer With Sealing, Solvent-Based",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "engineered",
      "concrete",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Does NOT provide anti-etch protection on marble.",
      "UV resistant, non-yellowing.",
      "Wait 24 hours for finished surface.",
      "No foot traffic for 4-6 hours after treatment.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true
  },
  "tenax hydrex polished stone sealer - 5 l": {
    "type": "sealer",
    "subtype": "Penetrating Impregnator, Solvent-Based, Natural Effect",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "quartzite",
      "marble",
      "granite",
      "engineered"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Does NOT change stone color - natural effect.",
      "Water and oil proof.",
      "Does NOT provide anti-etch protection on marble.",
      "5 liter bulk size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "24 hours full protection"
  },
  "tenax quarzo toner plus color enhancer sealer - 1 l": {
    "type": "enhancer",
    "subtype": "Color Enhancer With Sealing For Engineered Stone, Food-Safe",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "quartzite",
      "engineered",
      "granite"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Food contact approved (EC Reg 90/128 ECC).",
      "Conceals minor scratches and imperfections.",
      "UV stable - does not change color in sunlight.",
      "Oil and water resistance.",
      "1 liter size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax marble stain and etch remover for natural stone surfaces": {
    "type": "stain-remover",
    "subtype": "Stain And Etch Remover For Marble",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "limestone",
      "marble",
      "travertine"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "For marble and limestone surfaces.",
      "Addresses both stains and etch marks."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax marble rust and etch remover for natural stone surfaces": {
    "type": "stain-remover",
    "subtype": "Rust And Etch Remover For Marble",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "limestone",
      "marble",
      "travertine"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "For marble and limestone surfaces.",
      "Addresses both rust stains and etch marks."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax booster concentrated stone performance enhancer - 1 liter": {
    "type": "cleaner",
    "subtype": "Concentrated Alkaline Hard Surface Cleaner",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "engineered",
      "granite",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Concentrated formula - dilute before use.",
      "Alkaline cleaner for heavy-duty cleaning.",
      "1 liter size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax ager fs water-based color enhancing sealer - 1 quart": {
    "type": "enhancer",
    "subtype": "Water-Based Color Enhancer With Sealing, Food-Safe Certified",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "engineered",
      "concrete",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Food contact approved (EC Reg 90/128 ECC).",
      "Water-based - lower VOC.",
      "Conceals small scratches on engineered stone.",
      "UV stable - does not change color in sunlight.",
      "Coverage: 215-323 sq ft.",
      "2-year shelf life at 65-77F.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true
  },
  "tenax booster alk alkaline stain remover for natural stone surfaces": {
    "type": "cleaner",
    "subtype": "Concentrated Alkaline Hard Surface Cleaner",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "engineered",
      "granite",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Concentrated formula - dilute before use.",
      "Alkaline degreaser.",
      "Removes organic stains, grease, wax residue."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax petrolux trans 200 lt for stone fabrication": {
    "type": "enhancer",
    "subtype": "Penetrating Micro-Fissure Treatment And Color Enhancer",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "concrete",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "Liquid",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Disguises superficial micro-porosities and web-cracks.",
      "Enhances color and adds topical polish.",
      "200 liter industrial drum.",
      "Test on hidden area first.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true
  },
  "tenax ager 200 lt for natural stone for natural stone care": {
    "type": "enhancer",
    "subtype": "Penetrating Color Enhancer With Sealing, Solvent-Based",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "engineered",
      "concrete",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Does NOT provide anti-etch protection on marble.",
      "UV resistant, non-yellowing.",
      "200 liter industrial drum.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true
  },
  "tenax lustro italiano stone sealer 8.5 oz": {
    "type": "sealer",
    "subtype": "Consumer Spray Sealer With Polish",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "marble",
      "granite",
      "engineered",
      "travertine"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Part of Lustro Italiano consumer line.",
      "Aerosol spray with sealant.",
      "Coverage: ~120-150 sq ft per can.",
      "8.5 oz size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "problems": [
      "water-damage"
    ]
  },
  "tenax toner black stone dye 1 quart - professional grade": {
    "type": "enhancer",
    "subtype": "Concentrated Black Color Enhancer/Dye",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "mat": [
      "granite"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "Liquid",
    "colors": [
      "black"
    ],
    "warnings": [
      "Very strong concentrated black dye.",
      "Designed for black granite restoration.",
      "Follow up with Cera Black G for maintenance.",
      "Store at 65-77F, 12-month shelf life."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "app": [
      "enhancing"
    ]
  },
  "tenax sealer and wax remover for natural and engineered stone": {
    "type": "cleaner",
    "subtype": "Solvent-Based Sealer And Wax Stripper",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "engineered"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Removes both sealers and waxes from stone.",
      "Use before resealing stone surfaces."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax sealer and wax remover 1 quart for natural and engineered stone": {
    "type": "cleaner",
    "subtype": "Solvent-Based Sealer And Wax Stripper",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "engineered"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Removes both sealers and waxes from stone.",
      "Use before resealing stone surfaces.",
      "1 quart size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax zero purple liquid stain remover 1 liter": {
    "type": "stain-remover",
    "subtype": "Alkaline Active Chlorine Stain Remover",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "concrete",
      "travertine"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Contains active chlorine.",
      "Apply with roller or brush, leave 30-60 minutes, rinse.",
      "Not aggressive - safe for polished surfaces.",
      "Removes existing stains and prevents new spots."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax brioaction 2 mold remover for natural stone surfaces": {
    "type": "cleaner",
    "subtype": "Biodegradable Mold/Algae Remover And Sanitizer",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "concrete",
      "granite",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Removes mold, moss, algae, musk, and fungus.",
      "Biodegradable (>90%).",
      "Non-toxic and environmentally friendly.",
      "Also an effective sanitizer.",
      "12-month shelf life at 65-77F."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax booster acid extra strong 1 quart - professional grade": {
    "type": "cleaner",
    "subtype": "Concentrated Acid Descaler/Cleaner",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "porcelain",
      "engineered",
      "sintered"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "ACID - Do NOT use on marble, limestone, or other acid-sensitive stone.",
      "Concentrated - dilute before use.",
      "For end-of-site cleaning.",
      "Removes limescale, mineral deposits, joint residues, rust traces."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax booster alk easy 200 liter - professional grade": {
    "type": "stain-remover",
    "subtype": "Ready-To-Use Alkaline Spray Cleaner/Degreaser",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "engineered",
      "concrete",
      "granite",
      "porcelain"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Maximum contact time: 30 minutes.",
      "Removes organic stains, wax residue, food stains.",
      "200 liter industrial drum."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax skudo stone sealer 1 quart for natural and engineered stone": {
    "type": "sealer",
    "subtype": "Penetrating Impregnator, Water-Based, Natural Effect",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "quartzite",
      "engineered",
      "granite",
      "porcelain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Water-based formula.",
      "Food contact approved (EC Reg 1935/2004).",
      "Repels oil and water.",
      "Does not form surface films.",
      "1 quart size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "problems": [
      "water-damage"
    ]
  },
  "tenax luxor wax for natural stone for natural stone finishing": {
    "type": "polish",
    "subtype": "Self-Polishing Varnish For Stone Finishing",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "marble",
      "granite",
      "engineered",
      "travertine"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Forms hard anti-scratch film on surface.",
      "UV stable - does not yellow.",
      "Excellent for chiseled edges and areas where mechanical polishing is difficult."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax concrete sealer and water repellant": {
    "type": "sealer",
    "subtype": "Penetrating Water Repellent For Concrete",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "concrete"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Penetrates deep into concrete.",
      "Protects against water without altering breathability.",
      "Protects against algae and mold."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax petrolux transparent microfissure repair and polish": {
    "type": "enhancer",
    "subtype": "Penetrating Micro-Fissure Treatment And Color Enhancer",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "concrete",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "Liquid",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Disguises superficial micro-porosities and web-cracks on polished stone.",
      "Enhances color and adds topical polish.",
      "Best on polished dark granites.",
      "Test on hidden area first.",
      "Coverage: 215-323 sq ft per liter.",
      "2-year shelf life at 65-77F.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true
  },
  "tenax ager stone enhancing sealer 55 liter keg": {
    "type": "enhancer",
    "subtype": "Penetrating Color Enhancer With Sealing, Solvent-Based",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "engineered",
      "concrete",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Does NOT provide anti-etch protection on marble.",
      "UV resistant, non-yellowing.",
      "55 liter industrial keg.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true
  },
  "tenax terust rust remover 8 oz liquid for stone surfaces": {
    "type": "stain-remover",
    "subtype": "Liquid Rust Remover For Stone",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "concrete",
      "engineered",
      "travertine"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Specifically for rust stain removal from stone.",
      "8 oz liquid format."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax lustro italiano stone cleaner 32 fl oz": {
    "type": "cleaner",
    "subtype": "PH-Balanced Daily Stone Cleaner",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "engineered",
      "granite",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "PH balanced - no harmful solvents.",
      "Will not shorten life of stone sealant.",
      "Safe for daily use on all stone surfaces.",
      "Also works on ceramic, porcelain, stainless steel.",
      "32 fl oz size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax lustro italiano quartz cleaner 16 fl oz": {
    "type": "cleaner",
    "subtype": "Cleaner For Engineered Stone Surfaces",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "engineered"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Designed specifically for quartz and engineered stone.",
      "Part of Lustro Italiano consumer line.",
      "16 fl oz size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax quartz ax cleaner for engineered stone surfaces - 1 liter": {
    "type": "cleaner",
    "subtype": "Water-Based Acid Descaling Cleaner For Quartz",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "porcelain",
      "engineered",
      "sintered"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Do NOT use on marble or acid-sensitive stone - will cause corrosion and opacity.",
      "Do not use with hypochlorite-containing detergents.",
      "Leave 2-3 minutes, max 30 minutes, then rinse.",
      "Removes limescale and mineral deposits.",
      "1 liter size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax lustro italiano stone care kit - professional stone care": {
    "type": "kit",
    "subtype": "Consumer Stone Cleaner And Polish Kit",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "mat": [
      "marble",
      "granite",
      "engineered",
      "travertine"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Kit includes 32 oz cleaner + 11 oz polish spray.",
      "Safe for granite, marble, quartz, Corian.",
      "Polish coverage: ~120-150 sq ft per 11 oz can."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "problems": [
      "general-cleaning"
    ],
    "app": [
      "cleaning"
    ]
  },
  "tenax lustro italiano rust remover 8 oz for natural stone surfaces": {
    "type": "stain-remover",
    "subtype": "Rust Remover For Consumer Stone CAre",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "concrete",
      "engineered",
      "travertine"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Part of Lustro Italiano consumer line.",
      "Specifically for rust stains.",
      "8 oz size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax lustro italiano quartz stone care kit": {
    "type": "kit",
    "subtype": "Consumer Quartz Stone Cleaner And Polish Kit",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "mat": [
      "engineered"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Designed specifically for quartz and engineered stone.",
      "Part of Lustro Italiano consumer line."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "problems": [
      "general-cleaning"
    ],
    "app": [
      "cleaning"
    ]
  },
  "tenax lustro italiano quartz polish enhancer 8.5 oz": {
    "type": "polish",
    "subtype": "Consumer Aerosol Polish And Enhancer For Quartz",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "engineered"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Designed specifically for quartz and engineered stone.",
      "Aerosol spray format.",
      "Part of Lustro Italiano consumer line.",
      "8.5 oz size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax lustro italiano stone polish 11 fl oz": {
    "type": "polish",
    "subtype": "Consumer Aerosol Stone Polish With Sealant",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "marble",
      "granite",
      "engineered",
      "travertine"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Spray-on polish includes sealer for added luster.",
      "Coverage: ~120-150 sq ft per can.",
      "Part of Lustro Italiano consumer line.",
      "11 fl oz aerosol."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax teblossom and teclean stain removal kit": {
    "type": "kit",
    "subtype": "Stain Removal Kit With Poultice And Treatment",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "mat": [
      "marble",
      "granite",
      "engineered",
      "travertine"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Includes TeBlossom (green/blue stain remover) and TeClean (poultice powder).",
      "TeBlossom removes discoloration from chip repair processes.",
      "Does not etch stone."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "app": [
      "cleaning"
    ]
  },
  "tenax cement remover descaling agent 1 liter": {
    "type": "cleaner",
    "subtype": "Acid Descaling Detergent For Cement Removal",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "porcelain",
      "engineered",
      "sintered"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "ACID - Do NOT use on marble, limestone, or acid-sensitive stone.",
      "Does not contain hydrochloric acid.",
      "Water-based.",
      "Concentrated - dilute with water.",
      "Leave max 30 minutes then rinse.",
      "Saturate surface with water before applying."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax brioaction 3 professional stain remover": {
    "type": "cleaner",
    "subtype": "Biodegradable Professional Stain Remover And Sanitizer",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "concrete",
      "granite",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Heavy-duty cleanser for restoration and large areas.",
      "Biodegradable (>90%).",
      "Non-toxic and environmentally friendly.",
      "Also an effective sanitizer.",
      "12-month shelf life at 65-77F."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax lustro italiano stone cleaner for natural stone care": {
    "type": "cleaner",
    "subtype": "PH-Balanced Daily Stone Cleaner",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "engineered",
      "granite",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "PH balanced - no harmful solvents.",
      "Will not shorten life of stone sealant.",
      "Safe for daily use on all stone surfaces.",
      "Part of Lustro Italiano consumer line."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "strongbond cartridge glue - strong epoxy adhesive for lapitec and engineered stone": {
    "type": "adhesive",
    "subtype": "Epoxy (Bi-Component)",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "rodding",
      "seaming",
      "laminating",
      "repair"
    ],
    "mat": [
      "porcelain",
      "engineered",
      "sintered"
    ],
    "problems": [
      "bond-failure"
    ],
    "viscosity": "Gel",
    "colors": [
      "multiple Lapitec color-matched options"
    ],
    "warnings": [
      "Zero yellowing - UV stable.",
      "Solvent free.",
      "Requires Tenax 2:1 cartridge gun.",
      "Specifically designed for Lapitec sintered stone."
    ],
    "disc": false,
    "mix_ratio": "2:1 (pre-dosed cartridge)",
    "work_time": "30-60 min",
    "cure_time": "4-24 hr"
  },
  "tenax cd mastidek 215 ml - professional grade": {
    "type": "adhesive",
    "subtype": "Acrylic (Bi-Component Color-Matched)",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "seaming",
      "laminating",
      "repair"
    ],
    "mat": [
      "porcelain",
      "engineered",
      "sintered"
    ],
    "problems": [
      "bond-failure"
    ],
    "viscosity": "Gel",
    "colors": [
      "multiple Dekton/Cosentino color-matched options"
    ],
    "warnings": [
      "Zero yellowing - UV stable.",
      "Requires Tenax 2:1 cartridge gun.",
      "Color-matched for Dekton and Cosentino surfaces.",
      "215 ml cartridge."
    ],
    "disc": false,
    "mix_ratio": "2:1 (pre-dosed cartridge)",
    "work_time": "8-12 min",
    "cure_time": "20-30 min"
  },
  "tenax colored flowing polyester 1 quart - professional grade": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "fissures",
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "quartzite",
      "marble",
      "granite"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Flowing",
    "colors": [
      "multiple pre-colored options"
    ],
    "warnings": [
      "Interior only - not UV stable.",
      "Horizontal application only due to flowing consistency.",
      "Available in multiple pre-tinted colors.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work.",
      "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead."
    ],
    "disc": false,
    "mix_ratio": "100:2-3 (resin to hardener by weight)",
    "work_time": "4-6 min",
    "cure_time": "20-30 min"
  },
  "tenax epoxart kit 3:1 epoxy system for resin coating and stone repair": {
    "type": "adhesive",
    "subtype": "Epoxy Resining System",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "rodding",
      "repair"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "crack"
    ],
    "viscosity": "Flowing",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "For slab resining with fiberglass reinforcement.",
      "High transparency, high penetration, slow curing.",
      "Ideal for small batches.",
      "Stone must be completely dry and clean.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "3:1 (resin to hardener)",
    "work_time": "30-60 min",
    "cure_time": "4-24 hr"
  },
  "tenax fixtop a&b 1+1 liter two-part stone epoxy adhesive": {
    "type": "adhesive",
    "subtype": "Epoxy",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "rodding",
      "anchoring",
      "substrate-bonding",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "concrete",
      "granite",
      "porcelain"
    ],
    "problems": [
      "bond-failure"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "white (colorable)"
    ],
    "warnings": [
      "100% epoxy - not water-based.",
      "Does not dissolve or break down in water.",
      "Suitable for shower applications.",
      "VOC compliant.",
      "1+1 liter kit.",
      "Long cure time compared to polyester adhesives."
    ],
    "disc": false,
    "mix_ratio": "1:1",
    "work_time": "30-60 min",
    "cure_time": "4-24 hr"
  },
  "tenax fixtop and fixdeck epoxy parts for stone and porcelain bonding": {
    "type": "adhesive",
    "subtype": "Epoxy",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "rodding",
      "anchoring",
      "substrate-bonding",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "concrete",
      "granite",
      "porcelain"
    ],
    "problems": [
      "bond-failure"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "white (colorable)"
    ],
    "warnings": [
      "100% epoxy - not water-based.",
      "Does not dissolve or break down in water.",
      "Suitable for shower applications.",
      "VOC compliant.",
      "Long cure time compared to polyester adhesives."
    ],
    "disc": false,
    "mix_ratio": "1:1",
    "work_time": "30-60 min",
    "cure_time": "4-24 hr"
  },
  "tenax fixtop fixdeck a+b slow curing tile and stone epoxy": {
    "type": "adhesive",
    "subtype": "Epoxy",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "rodding",
      "substrate-bonding",
      "repair"
    ],
    "mat": [
      "engineered",
      "marble",
      "concrete",
      "granite",
      "porcelain"
    ],
    "problems": [
      "bond-failure"
    ],
    "viscosity": "Paste",
    "colors": [],
    "warnings": [
      "Slow-cure formula for extended working time.",
      "Water-resistant - suitable for outdoor/shower use.",
      "Apply in thin layers.",
      "Service temp range: -13 to 143F after cure.",
      "Long cure time compared to polyester adhesives."
    ],
    "disc": false,
    "mix_ratio": "1:1",
    "work_time": "90 min (gel time at 77F)",
    "cure_time": "tack-free ~4 hours"
  },
  "tenax glaxs color match cartridge adhesive 215 ml": {
    "type": "adhesive",
    "subtype": "Acrylic",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "seaming",
      "repair",
      "mitering",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "granite",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Gel",
    "colors": [
      "50+ color-matched options"
    ],
    "warnings": [
      "Zero VOC.",
      "Zero yellowing.",
      "Requires Tenax 2:1 cartridge gun.",
      "Cures down to 34F.",
      "12-month shelf life at 65-77F.",
      "Service temp: -13 to 140F."
    ],
    "disc": false,
    "mix_ratio": "2:1 (pre-dosed cartridge)",
    "work_time": "3-5 min (gel time at 77F)",
    "cure_time": "~15-25 min"
  },
  "tenax glaxs easy tube epoxy adhesive for granite and marble": {
    "type": "adhesive",
    "subtype": "Acrylic-Resin",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "fissures",
      "repair",
      "laminating"
    ],
    "mat": [
      "quartzite",
      "marble",
      "granite",
      "engineered"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Flowing",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Zero yellowing - 15-year guarantee.",
      "Solvent free, low viscosity, odorless.",
      "Cure time not affected by temperature.",
      "Easy squeeze-tube format - no gun needed.",
      "Good for pitholes and slab filling.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "8-12 min",
    "cure_time": "~20-25 min"
  },
  "tenax glaxs ultra fast transparent chip repair 50 ml": {
    "type": "adhesive",
    "subtype": "Acrylic Chip Repair",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "repair"
    ],
    "mat": [
      "porcelain",
      "marble",
      "granite",
      "engineered"
    ],
    "problems": [
      "crack"
    ],
    "viscosity": "Flowing",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Ultra-fast curing - 1 minute gel time.",
      "Zero yellowing - UV stable.",
      "Zero VOC.",
      "Requires 2:1 ratio cartridge gun.",
      "Cures at low temperatures (down to 1C).",
      "50 ml size.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "2:1 (pre-dosed cartridge)",
    "work_time": "~1 min (gel time at 77F)",
    "cure_time": "tack-free ~4 min"
  },
  "tenax micto two-part protective coating system for stone - 2 liter kit": {
    "type": "adhesive",
    "subtype": "Epoxy",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "rodding",
      "fissures",
      "repair"
    ],
    "mat": [
      "quartzite",
      "marble",
      "granite",
      "engineered"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Flowing",
    "colors": [
      "water clear"
    ],
    "warnings": [
      "Will yellow when exposed to sunlight (use in non-visible areas outdoors).",
      "VOC compliant.",
      "2-year shelf life at 65-77F.",
      "2 liter kit.",
      "Runs on vertical surfaces - use knife-grade for vertical work.",
      "Long cure time compared to polyester adhesives."
    ],
    "disc": false,
    "mix_ratio": "1:1",
    "work_time": "30-60 min",
    "cure_time": "~15 min"
  },
  "tenax poxart kit 2:1 epoxy system for resin coating and stone repair": {
    "type": "adhesive",
    "subtype": "Epoxy Resining System",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "rodding",
      "repair"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "crack"
    ],
    "viscosity": "Flowing",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "For slab resining with fiberglass reinforcement.",
      "High penetration.",
      "Stone must be completely dry and clean.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "2:1 (resin to hardener)",
    "work_time": "30-60 min",
    "cure_time": "4-24 hr"
  },
  "tenax poxart kit 4:1 epoxy system for resin coating and stone repair": {
    "type": "adhesive",
    "subtype": "Epoxy Resining System",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "rodding",
      "repair"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "crack"
    ],
    "viscosity": "Flowing",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "For slab resining with fiberglass reinforcement.",
      "Highest dilution ratio - most penetration, slowest cure.",
      "Stone must be completely dry and clean.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "4:1 (resin to hardener)",
    "work_time": "30-60 min",
    "cure_time": "4-24 hr"
  },
  "tenax rivo a&b 1+1 liter two-part stone bonding epoxy": {
    "type": "adhesive",
    "subtype": "Epoxy",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "rodding",
      "anchoring",
      "substrate-bonding",
      "seaming",
      "laminating",
      "repair"
    ],
    "mat": [
      "engineered",
      "marble",
      "concrete",
      "granite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "straw (colorable with Tenax Universal Colors)"
    ],
    "warnings": [
      "VOC compliant.",
      "Bonds to nearly any surface.",
      "1+1 liter kit.",
      "Long cure time compared to polyester adhesives."
    ],
    "disc": false,
    "mix_ratio": "1:1",
    "work_time": "15 min (gel time)",
    "cure_time": "~90 min"
  },
  "tenax semisolido wet buff semi-solid polish for granite marble - 4 liter": {
    "type": "polish",
    "subtype": "Semi-Solid Polishing Compound",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "marble",
      "granite",
      "travertine"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "Semi Solid",
    "colors": [],
    "warnings": [
      "For wet buffing/polishing stone surfaces.",
      "Apply with buffing machine and felt pad.",
      "4 liter container."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax tixo extra knife grade transparent": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "fissures",
      "repair"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Interior only - not UV stable.",
      "May yellow on light-colored marble over time.",
      "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead.",
      "Tixo is a repair and fissure-fill product. NOT for structural seaming or lamination."
    ],
    "disc": false,
    "mix_ratio": "100:2-3 (resin to hardener by weight)",
    "work_time": "4-6 min",
    "cure_time": "20-30 min"
  },
  "tenax tixo x prism polyester knife grade adhesive for granite and marble": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "fissures",
      "repair"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Interior only - not UV stable.",
      "May yellow on light-colored marble over time.",
      "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead.",
      "Tixo is a repair and fissure-fill product. NOT for structural seaming or lamination."
    ],
    "disc": false,
    "mix_ratio": "100:2-3 (resin to hardener by weight)",
    "work_time": "4-6 min",
    "cure_time": "20-30 min"
  },
  "tenax transparent flowing polyester - professional grade": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "fissures",
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "quartzite",
      "marble",
      "granite"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Flowing",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Interior only - not UV stable.",
      "Horizontal application only due to flowing consistency.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work.",
      "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead."
    ],
    "disc": false,
    "mix_ratio": "100:2-3 (resin to hardener by weight)",
    "work_time": "4-6 min",
    "cure_time": "20-30 min"
  },
  "tenax transparent knife grade h - professional grade": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "fissures",
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Interior only - not UV stable.",
      "Requires Tenax hardener.",
      "May yellow on light-colored marble over time.",
      "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead."
    ],
    "disc": false,
    "mix_ratio": "100:2-3 (resin to hardener by weight)",
    "work_time": "4-6 min",
    "cure_time": "20-30 min"
  },
  "tenax ultra-fast epoxy plus cartridge glue 210 ml": {
    "type": "adhesive",
    "subtype": "Epoxy",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "rodding",
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "porcelain",
      "marble",
      "granite",
      "engineered"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Gel",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Ultra-fast curing.",
      "Requires Tenax 2:1 cartridge gun.",
      "210 ml cartridge.",
      "Long cure time compared to polyester adhesives."
    ],
    "disc": false,
    "mix_ratio": "2:1 (pre-dosed cartridge)",
    "work_time": "30-60 min",
    "cure_time": "4-24 hr"
  },
  "tenax vertigo s vinyl ester knife grade - 1 gallon": {
    "type": "adhesive",
    "subtype": "Vinyl-Ester",
    "vendor": "Tenax",
    "env": [
      "exterior",
      "interior"
    ],
    "app": [
      "rodding",
      "fissures",
      "mitering",
      "seaming",
      "laminating",
      "repair"
    ],
    "mat": [
      "engineered",
      "marble",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "water clear"
    ],
    "warnings": [
      "Low yellowing - formulated for UV resistance.",
      "Drip-less formula.",
      "1 gallon size."
    ],
    "disc": false,
    "mix_ratio": "100:2-3 (resin to catalyst by weight)",
    "work_time": "4-5 min (gel time)",
    "cure_time": "25 min"
  },
  "tenax vertigo t vinyl ester knife grade - professional grade": {
    "type": "adhesive",
    "subtype": "Vinyl-Ester",
    "vendor": "Tenax",
    "env": [
      "exterior",
      "interior"
    ],
    "app": [
      "rodding",
      "fissures",
      "mitering",
      "seaming",
      "laminating",
      "repair"
    ],
    "mat": [
      "engineered",
      "marble",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "water clear"
    ],
    "warnings": [
      "Low yellowing - formulated for UV resistance.",
      "Thicker consistency than Vertigo S."
    ],
    "disc": false,
    "mix_ratio": "100:2-3 (resin to catalyst by weight)",
    "work_time": "4-5 min (gel time)",
    "cure_time": "20 min"
  },
  "tenax teblossom green blossom stain removal kit": {
    "type": "stain-remover",
    "subtype": "Two-Part Chemical Poultice For Green/Blue Stain Removal",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "concrete",
      "engineered",
      "travertine"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Removes green/blue stains caused by chip repair kits.",
      "Two-part poultice process.",
      "Does not etch stone."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "tenax ager pen 6-piece stone scratch concealer & color enhancer set": {
    "type": "enhancer",
    "subtype": "Pen-Format Color Enhancer For Scratch Concealment",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "engineered",
      "concrete",
      "granite",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [
      "6-piece set with assorted colors"
    ],
    "warnings": [
      "Pen format for precision scratch concealment.",
      "Color enhancing.",
      "Set of 6 pens.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true
  },
  "tenax titanium kg stone sealer & color enhancer - 1 qt": {
    "type": "enhancer",
    "subtype": "Penetrating Color Enhancer With Sealing",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "engineered",
      "concrete",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Color enriching stone enhancer and sealer.",
      "UV resistant.",
      "1 quart size.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true
  },
  "tenax water ager water-based color enhancing sealer - 1 liter": {
    "type": "enhancer",
    "subtype": "Water-Based Color Enhancer With Sealing",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "engineered",
      "concrete",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Water-based formula - lower VOC than solvent-based Ager.",
      "Color enhancing with sealing properties.",
      "1 liter size.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true
  },
  "tenax pectro black 1 quart dark stone micro fissure & webbing concealer": {
    "type": "enhancer",
    "subtype": "Micro-Fissure And Webbing Concealer For Dark Stone",
    "vendor": "Tenax",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "granite"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "Liquid",
    "colors": [
      "black"
    ],
    "warnings": [
      "For dark granites only (black, brown, green).",
      "Hides micro fissures and webbing.",
      "UV resistant for outdoor use.",
      "Immediately buff with clean cloth after application.",
      "2-year shelf life at 65-77F."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "5 min drying time"
  },
  "tenax universal stone chip repair kit - professional stone care": {
    "type": "kit",
    "subtype": "Chip Repair Kit For Stone Surfaces",
    "vendor": "Tenax",
    "env": [
      "interior"
    ],
    "mat": [
      "marble",
      "granite",
      "engineered"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Kit includes repair components for various chip sizes.",
      "For scratches, chips, and blemishes on stone."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "problems": [
      "crack"
    ],
    "app": [
      "cleaning"
    ]
  },
  "akemi akenova lion grip 50 (cc 1100 white) - 290 ml cartridge": {
    "type": "adhesive",
    "subtype": "Polyhybrid",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "anchoring",
      "substrate-bonding",
      "repair"
    ],
    "mat": [
      "marble",
      "glass",
      "ceramic",
      "wood",
      "metal",
      "concrete",
      "granite"
    ],
    "problems": [
      "bond-failure"
    ],
    "viscosity": "Paste",
    "colors": [
      "white"
    ],
    "warnings": [
      "For professional use only."
    ],
    "disc": false,
    "mix_ratio": "N/A - 1 component",
    "work_time": "adjustable",
    "cure_time": "24 hours full cure"
  },
  "akemi marble filler super 1 kg. - highly liquid acrylic adhesive": {
    "type": "adhesive",
    "subtype": "Acrylic",
    "vendor": "Akemi",
    "env": [
      "interior"
    ],
    "mat": [
      "limestone",
      "marble",
      "granite",
      "travertine"
    ],
    "problems": [
      "crack"
    ],
    "viscosity": "Highly Liquid / Super Flowing",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Interior use only.",
      "For professional use only.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "resin + 1-4% BPO hardener",
    "work_time": "5-10 minutes at 68 degrees F",
    "cure_time": "20-50 minutes at 68 degrees F",
    "app": [
      "seaming",
      "repair"
    ]
  },
  "akemi marble filler 1000 transparent l-special waterclear - quart": {
    "type": "filler",
    "subtype": "Polyester",
    "vendor": "Akemi",
    "env": [
      "interior"
    ],
    "app": [
      "fissures",
      "repair"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "crack"
    ],
    "viscosity": "Flowing",
    "colors": [
      "transparent water-clear"
    ],
    "warnings": [
      "Interior use only.",
      "Less BPO hardener needed in hot temperatures.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "resin + 1-4% BPO hardener",
    "work_time": "5-10 minutes at 68 degrees F (20 degrees C)",
    "cure_time": "20-50 minutes at 68 degrees F (20 degrees C)"
  },
  "akemi marble filler 1000 transparent l-special 1 kg. - knife-grade polyester adhesive": {
    "type": "filler",
    "subtype": "Polyester",
    "vendor": "Akemi",
    "env": [
      "interior"
    ],
    "app": [
      "fissures",
      "repair"
    ],
    "mat": [
      "estremoz",
      "marble",
      "thassos",
      "limestone",
      "palisandro",
      "granite",
      "carrara",
      "onyx",
      "travertine"
    ],
    "problems": [
      "crack"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "transparent water-clear"
    ],
    "warnings": [
      "Interior use only.",
      "Less BPO hardener needed in extremely hot temperatures.",
      "May yellow on light-colored marble over time."
    ],
    "disc": false,
    "mix_ratio": "resin + 2-4% BPO hardener by weight",
    "work_time": "4-6 minutes at 70 degrees F (20 degrees C)",
    "cure_time": "20-30 minutes at 70 degrees F (20 degrees C)"
  },
  "akemi acrylic penetrant 900 ml - deep penetrating adhesive for marble repair": {
    "type": "adhesive",
    "subtype": "Acrylic",
    "vendor": "Akemi",
    "env": [
      "interior"
    ],
    "mat": [
      "limestone",
      "marble",
      "granite",
      "travertine"
    ],
    "problems": [
      "crack"
    ],
    "viscosity": "Highly Liquid / Penetrating",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Interior use only.",
      "For professional use only."
    ],
    "disc": false,
    "mix_ratio": "resin + 1-4% BPO hardener",
    "work_time": "5-10 minutes at 68 degrees F",
    "cure_time": "20-50 minutes at 68 degrees F",
    "app": [
      "fissures",
      "repair"
    ]
  },
  "akemi platinum 5.0 p+ epoxyacrylate knife grade 4500 ml - large format adhesive": {
    "type": "adhesive",
    "subtype": "Epoxyacrylate",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "rodding",
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "marble",
      "granite",
      "sintered",
      "quartz",
      "porcelain"
    ],
    "problems": [
      "bond-failure"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "transparent-opaque (very light base color)"
    ],
    "warnings": [
      "For professional use only."
    ],
    "disc": false,
    "mix_ratio": "1:1",
    "work_time": "10-12",
    "cure_time": "1440"
  },
  "akemi everclear 505 flowing uv resistant urethane adhesive 2 liter 1900g": {
    "type": "filler",
    "subtype": "Polyurethane",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "repair"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble"
    ],
    "problems": [
      "crack"
    ],
    "viscosity": "Flowing",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "For professional use only.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "4:3",
    "work_time": "15",
    "cure_time": "360"
  },
  "akemi akenova crystal clear adhesive sealant 290 ml - paintable sink adhesive": {
    "type": "adhesive",
    "subtype": "Polyhybrid",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "substrate-bonding",
      "repair"
    ],
    "mat": [
      "engineered",
      "marble",
      "ceramic",
      "granite",
      "stainless steel"
    ],
    "problems": [
      "bond-failure"
    ],
    "viscosity": "Paste",
    "colors": [
      "crystal clear"
    ],
    "warnings": [
      "For professional use only."
    ],
    "disc": false,
    "mix_ratio": "N/A - 1 component",
    "work_time": "4-6 min",
    "cure_time": "24 hours full cure"
  },
  "akenova clear 300 cc 2200 290ml cartridge": {
    "type": "adhesive",
    "subtype": "Polyhybrid",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "substrate-bonding",
      "repair"
    ],
    "mat": [
      "engineered",
      "marble",
      "ceramic",
      "granite",
      "stainless steel"
    ],
    "problems": [
      "bond-failure"
    ],
    "viscosity": "Paste",
    "colors": [
      "crystal clear"
    ],
    "warnings": [
      "For professional use only."
    ],
    "disc": false,
    "mix_ratio": "N/A - 1 component",
    "work_time": "4-6 min",
    "cure_time": "24 hours full cure"
  },
  "akenova elastic 100 grey 1830 290ml cartridge": {
    "type": "adhesive",
    "subtype": "Polyhybrid",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "substrate-bonding",
      "repair"
    ],
    "mat": [
      "glass",
      "marble",
      "ceramic",
      "wood",
      "metal",
      "granite"
    ],
    "problems": [
      "bond-failure"
    ],
    "viscosity": "Paste",
    "colors": [
      "grey"
    ],
    "warnings": [
      "For professional use only."
    ],
    "disc": false,
    "mix_ratio": "N/A - 1 component",
    "work_time": "4-6 min",
    "cure_time": "24 hours full cure"
  },
  "akenova rocket 200 white 1130 290ml cartridge": {
    "type": "adhesive",
    "subtype": "Polyhybrid",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "substrate-bonding",
      "repair"
    ],
    "mat": [
      "glass",
      "marble",
      "ceramic",
      "wood",
      "metal",
      "granite"
    ],
    "problems": [
      "bond-failure"
    ],
    "viscosity": "Paste",
    "colors": [
      "white"
    ],
    "warnings": [
      "For professional use only."
    ],
    "disc": false,
    "mix_ratio": "N/A - 1 component",
    "work_time": "4-6 min",
    "cure_time": "fast initial tack, 24 hours full cure"
  },
  "akemi white cc 1130 two-component stone adhesive cartridge 400 ml": {
    "type": "adhesive",
    "subtype": "Epoxy (Two-Component CArtridge)",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "rodding",
      "mitering",
      "seaming",
      "laminating",
      "repair"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "white"
    ],
    "warnings": [
      "Requires mixing nozzle.",
      "For professional use only."
    ],
    "disc": false,
    "mix_ratio": "auto-metered dual cartridge",
    "work_time": "30-60 min",
    "cure_time": "4-24 hr"
  },
  "akemi triple effect 500 ml - food-safe stone care and impregnation spray": {
    "type": "sealer",
    "subtype": "Impregnation Spray",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble",
      "travertine"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "Liquid Spray",
    "colors": [],
    "warnings": [
      "Shake well before use."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "afin acryclean 500ml solvent-based ready-to-use silicone remover for natural stone": {
    "type": "cleaner",
    "subtype": "Solvent-Based",
    "vendor": "Akemi (Afin sub-brand)",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Solvent-based - ensure ventilation.",
      "Test on inconspicuous area first."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi natural stone basic cleaner 500 ml - food-safe alkaline cleaning agent": {
    "type": "cleaner",
    "subtype": "Water-Based",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "limestone",
      "marble",
      "granite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi rust remover 1l - acidic cleaning agent": {
    "type": "cleaner",
    "subtype": "Acidic",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "granite",
      "sandstone"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Do NOT use on acid-sensitive stones (marble, limestone, travertine).",
      "For professional use only."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi good-bye stain 500 ml - alcaline cleaning agent": {
    "type": "cleaner",
    "subtype": "Water-Based",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi transformer 500 ml - premium protection and colour intensification sealer": {
    "type": "enhancer",
    "subtype": "Solvent-Based",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "terrazzo",
      "limestone",
      "concrete",
      "granite",
      "sintered",
      "quartz",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Solvent-based impregnation sealer.",
      "Ground shipping only.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use, single component",
    "work_time": "",
    "cure_time": "5-10 minutes at 20 degrees C for color intensification",
    "not_for_restoration": true
  },
  "akemi quartz clean & care 500 ml - food-safe daily quartz cleaning agent": {
    "type": "cleaner",
    "subtype": "Water-Based",
    "vendor": "Akemi",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "engineered",
      "quartz"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi stone sealer mat finish 1l - acrylic sealer": {
    "type": "sealer",
    "subtype": "Acrylic",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "limestone",
      "marble",
      "granite",
      "sandstone"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "For professional use only."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi quartz polish 250 ml - food-safe quartz care product": {
    "type": "polish",
    "subtype": "Polish",
    "vendor": "Akemi",
    "env": [
      "interior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "engineered",
      "quartz"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "Liquid/Cream",
    "colors": [],
    "warnings": [],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi rust remover marble 1l - alkaline cleaning agent": {
    "type": "cleaner",
    "subtype": "Alkaline",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "granite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Safe for acid-sensitive stones unlike standard rust remover."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi stone cleaner 1l - concentrated alkaline cleaning agent": {
    "type": "cleaner",
    "subtype": "Water-Based",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "limestone",
      "marble",
      "granite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [],
    "disc": false,
    "mix_ratio": "concentrated - dilutable",
    "work_time": "",
    "cure_time": ""
  },
  "akemi crystal clean 500 ml - food-safe daily cleaning agent": {
    "type": "cleaner",
    "subtype": "Water-Based",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi oil and grease remover paste 250 ml": {
    "type": "cleaner",
    "subtype": "Paste Poultice",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Paste",
    "colors": [],
    "warnings": [
      "Apply paste, cover, let draw out stain, remove after drying."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi darkener plus 1l - colour-intensifying sealer": {
    "type": "enhancer",
    "subtype": "Solvent-Based",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "terrazzo",
      "limestone",
      "concrete",
      "slate",
      "granite",
      "sintered",
      "porcelain",
      "cotto"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Solvent-based product.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use, single component",
    "work_time": "",
    "cure_time": "protective effect begins approx. 24-48 hours at 20 degrees C",
    "not_for_restoration": true
  },
  "akemi impregnation remover 1l - alkaline cleaning agent": {
    "type": "cleaner",
    "subtype": "Alkaline",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Removes existing impregnation/sealer - reapply sealer after use."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi stone impregnation sealer for granite & natural stone": {
    "type": "sealer",
    "subtype": "Solvent-Based Impregnation",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "limestone",
      "marble",
      "granite",
      "sandstone"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Stone must be totally dry before application (1-2 days minimum)."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use, single component",
    "work_time": "",
    "cure_time": "fully effective after 2-3 hours; initial protection in 10-20 minutes at 20 degrees C"
  },
  "akemi transformer quartz 1000 ml - color enhancer for quartz": {
    "type": "enhancer",
    "subtype": "Solvent-Based",
    "vendor": "Akemi",
    "env": [
      "interior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "engineered",
      "quartz"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Designed specifically for engineered quartz surfaces."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi triple effect 250 ml spray - 3-in-1 stone cleaner, sealer, and polish": {
    "type": "sealer",
    "subtype": "Impregnation Spray",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble",
      "travertine"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "Liquid Spray",
    "colors": [],
    "warnings": [
      "Shake well before use."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi liqui polish universal 650 ml - liquid polishing compound": {
    "type": "polish",
    "subtype": "Liquid Polishing Compound",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble",
      "travertine"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "Liquid/Cream",
    "colors": [],
    "warnings": [
      "For professional use only."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi stone polish wax based 1 liter - natural wax polish for stone surfaces": {
    "type": "polish",
    "subtype": "Wax-Based",
    "vendor": "Akemi",
    "env": [
      "interior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "marble",
      "granite",
      "travertine"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "Liquid/Cream",
    "colors": [],
    "warnings": [],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi antigraffiti protective coating - special order": {
    "type": "sealer",
    "subtype": "Protective Coating",
    "vendor": "Akemi",
    "env": [
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "marble",
      "granite",
      "concrete"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Special order item - longer lead time."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": "",
    "problems": [
      "water-damage"
    ]
  },
  "akemi pearl fast curing impregnator - stain blocker for quartzite": {
    "type": "sealer",
    "subtype": "Impregnation",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "quartzite",
      "granite"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": "fast curing"
  },
  "akemi transformer quartz enhancer and sealer for engineered quartz": {
    "type": "enhancer",
    "subtype": "Solvent-Based",
    "vendor": "Akemi",
    "env": [
      "interior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "engineered",
      "quartz"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Designed specifically for engineered quartz surfaces."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi transformer exotic enhancer impregnator - for exotic stones": {
    "type": "enhancer",
    "subtype": "Solvent-Based",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "concrete",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Solvent-based product.",
      "For exotic stones with high absorption.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true
  },
  "akemi transformer enhancer and impregnator - color enhancing sealer": {
    "type": "enhancer",
    "subtype": "Solvent-Based",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "terrazzo",
      "limestone",
      "concrete",
      "granite",
      "sintered",
      "quartz",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Solvent-based impregnation sealer.",
      "Ground shipping only.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use, single component",
    "work_time": "",
    "cure_time": "5-10 minutes at 20 degrees C for color intensification",
    "not_for_restoration": true
  },
  "akemi marble rust remover 500 ml - safe rust stain removal for marble": {
    "type": "cleaner",
    "subtype": "Alkaline",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "granite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Safe for acid-sensitive stones."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi marble rust remover 1000 ml - professional rust stain removal for marble": {
    "type": "cleaner",
    "subtype": "Alkaline",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "granite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Safe for acid-sensitive stones."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi rust remover paste 1l - acidic cleaning paste": {
    "type": "cleaner",
    "subtype": "Acidic Paste",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "granite",
      "sandstone"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Paste",
    "colors": [],
    "warnings": [
      "Do NOT use on acid-sensitive stones (marble, limestone, travertine).",
      "Paste form for vertical application."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi spider 1000 ml - flexible stone joint sealer and enhancer": {
    "type": "sealer",
    "subtype": "Flexible Joint Sealer",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": "",
    "app": [
      "sealing"
    ]
  },
  "akemi wax stripper 1 liter - wax and coating remover for stone": {
    "type": "cleaner",
    "subtype": "Stripping Agent",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Removes protective wax coatings - reapply sealer after use."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use or dilutable",
    "work_time": "",
    "cure_time": ""
  },
  "akemi algae and mildew remover longlife 1 liter - extended protection": {
    "type": "cleaner",
    "subtype": "Water-Based",
    "vendor": "Akemi",
    "env": [
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "granite",
      "brick",
      "concrete",
      "marble",
      "travertine"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Extended protection formula - prevents regrowth."
    ],
    "disc": false,
    "mix_ratio": "concentrated",
    "work_time": "",
    "cure_time": ""
  },
  "akemi algae and mildew remover power 1 liter - fast-acting outdoor cleaner": {
    "type": "cleaner",
    "subtype": "Water-Based",
    "vendor": "Akemi",
    "env": [
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "granite",
      "brick",
      "concrete",
      "marble",
      "travertine"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Fast-acting formula for immediate results."
    ],
    "disc": false,
    "mix_ratio": "ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi wax stripper 1 liter - professional wax and coating remover for stone": {
    "type": "cleaner",
    "subtype": "Stripping Agent",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Removes protective wax coatings - reapply sealer after use."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use or dilutable",
    "work_time": "",
    "cure_time": ""
  },
  "akemi graffiti remover 1 liter - paint and graffiti cleaner for stone": {
    "type": "cleaner",
    "subtype": "Solvent-Based",
    "vendor": "Akemi",
    "env": [
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "concrete"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Solvent-based - ensure ventilation.",
      "Test on inconspicuous area first."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi algae and mildew remover longlife 1 liter - long-lasting protection": {
    "type": "cleaner",
    "subtype": "Water-Based",
    "vendor": "Akemi",
    "env": [
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "granite",
      "brick",
      "concrete",
      "marble",
      "travertine"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Extended protection formula - prevents regrowth."
    ],
    "disc": false,
    "mix_ratio": "concentrated",
    "work_time": "",
    "cure_time": ""
  },
  "akemi quartz intensive cleaner and stain remover 250 ml for engineered stone": {
    "type": "cleaner",
    "subtype": "Water-Based",
    "vendor": "Akemi",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "engineered",
      "quartz"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi epoxy remover 1000 ml - professional epoxy residue cleaner for stone": {
    "type": "cleaner",
    "subtype": "Solvent-Based",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Solvent-based - ensure ventilation.",
      "Test on inconspicuous area first."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi transformer exotic 500 ml - premium protection and colour intensification sealer for exotic stones": {
    "type": "enhancer",
    "subtype": "Solvent-Based",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "concrete",
      "granite",
      "sintered",
      "quartzite",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "Solvent-based product.",
      "For exotic stones with high absorption.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true
  },
  "akemi everclear 510 knife-grade - quart": {
    "type": "adhesive",
    "subtype": "Polyurethane",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "seaming",
      "repair"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble"
    ],
    "problems": [
      "bond-failure"
    ],
    "viscosity": "Gel / Knife Grade",
    "colors": [],
    "warnings": [
      "For professional use only."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "10 minutes",
    "cure_time": "60-90 min"
  },
  "akemi solid wax transparent 750 ml - clear protective stone wax": {
    "type": "polish",
    "subtype": "Solid Wax",
    "vendor": "Akemi",
    "env": [
      "interior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "marble",
      "granite",
      "travertine"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "Solid Wax",
    "colors": [
      "transparent"
    ],
    "warnings": [],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "akemi hyperclear 1 kg. - ultra strong 2-component clear urethane adhesive": {
    "type": "adhesive",
    "subtype": "Polyurethane (Two-Component)",
    "vendor": "Akemi",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ],
    "viscosity": "Flowing To Gel",
    "colors": [],
    "warnings": [
      "Two-component system - mix per instructions.",
      "For professional use only.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1:1",
    "work_time": "5-8",
    "cure_time": "120"
  },
  "superior gold acrylic vinyl ester knife grade adhesives": {
    "type": "adhesive",
    "subtype": "Acrylic Vinyl Ester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "rodding",
      "seaming",
      "mitering",
      "laminating"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "clear/translucent"
    ],
    "warnings": [
      "Indoor use only."
    ],
    "disc": false,
    "mix_ratio": "1%-2% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-25 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior polyester transparent knife grade adhesives": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "limestone",
      "marble",
      "granite"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Indoor use only.",
      "May yellow on light-colored marble over time."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior ice instant color enhancement for natural stone": {
    "type": "enhancer",
    "subtype": "Color Enhancer",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "mat": [
      "marble",
      "limestone",
      "concrete",
      "granite",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "For natural stone only - not engineered stone.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true,
    "app": [
      "enhancing"
    ]
  },
  "superior pearl ehc thicker knife grade adhesives": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "mitering",
      "laminating"
    ],
    "mat": [
      "limestone",
      "marble",
      "granite"
    ],
    "viscosity": "Thick Knife Grade",
    "colors": [
      "transparent/pearl"
    ],
    "warnings": [
      "Indoor use only.",
      "Extra thick - ideal for vertical applications.",
      "May yellow on light-colored marble over time."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior v-max premium vinyl ester sv-9 adhesives": {
    "type": "adhesive",
    "subtype": "Vinyl Ester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior and exterior"
    ],
    "app": [
      "rodding",
      "seaming",
      "mitering",
      "laminating"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble"
    ],
    "viscosity": "Thick Knife Grade (Sv 9)",
    "colors": [
      "clear/translucent"
    ],
    "warnings": [
      "Suitable for exterior use."
    ],
    "disc": false,
    "mix_ratio": "1%-2% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior bronze polyester flowing adhesives": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "repair",
      "laminating"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "viscosity": "Flowing",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Indoor use only.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior bronze polyester knife grade adhesives": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Indoor use only.",
      "May yellow on light-colored marble over time."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior polyester white knife grade adhesives": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "white"
    ],
    "warnings": [
      "Indoor use only.",
      "Pre-colored white - not transparent.",
      "May yellow on light-colored marble over time."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior fire instant color enhancement for exotic natural stone": {
    "type": "enhancer",
    "subtype": "Color Enhancer",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "mat": [
      "quartzite",
      "granite"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "For exotic natural stone only."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": "",
    "app": [
      "enhancing"
    ]
  },
  "superior acrylic super flowing adhesive - special order": {
    "type": "adhesive",
    "subtype": "Acrylic",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "viscosity": "Super Flowing (Very Low Viscosity)",
    "colors": [],
    "warnings": [
      "Special order item - longer lead time.",
      "Indoor use only.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "5-10 minutes @ 70 degrees F",
    "cure_time": "20-50 minutes @ 70 degrees F",
    "app": [
      "fissures",
      "repair"
    ],
    "problems": [
      "crack"
    ]
  },
  "superior acrylic quickset flowing adhesives - special order": {
    "type": "adhesive",
    "subtype": "Acrylic",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "viscosity": "Flowing",
    "colors": [],
    "warnings": [
      "Special order item - longer lead time.",
      "Indoor use only.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "8-12 min",
    "cure_time": "fast (quickset formula)",
    "app": [
      "fissures",
      "repair"
    ],
    "problems": [
      "crack"
    ]
  },
  "superior gold evolution ev-9 thick knife grade adhesives": {
    "type": "adhesive",
    "subtype": "Modified Acrylic Vinyl Ester With Colored Hardener",
    "vendor": "Superior Stone Products",
    "env": [
      "interior and exterior"
    ],
    "app": [
      "rodding",
      "mitering",
      "seaming",
      "laminating",
      "repair"
    ],
    "mat": [
      "engineered",
      "granite",
      "sintered",
      "quartz",
      "porcelain"
    ],
    "viscosity": "Thick Knife Grade",
    "colors": [
      "20 colored hardener options"
    ],
    "warnings": [
      "Temperature dependent cure times."
    ],
    "disc": false,
    "mix_ratio": "3%-5% GOLD EVOLUTION Colored Hardener by weight",
    "work_time": "3-5 minutes @ 70 degrees F",
    "cure_time": "13 minutes average",
    "problems": [
      "crack"
    ]
  },
  "superior gold evolution ev-1 flowing adhesives": {
    "type": "adhesive",
    "subtype": "Modified Acrylic Vinyl Ester With Colored Hardener",
    "vendor": "Superior Stone Products",
    "env": [
      "interior and exterior"
    ],
    "app": [
      "rodding",
      "repair",
      "laminating"
    ],
    "mat": [
      "engineered",
      "granite",
      "sintered",
      "quartz",
      "porcelain"
    ],
    "viscosity": "Flowing",
    "colors": [
      "20 colored hardener options"
    ],
    "warnings": [
      "Temperature dependent cure times.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "3%-5% GOLD EVOLUTION Colored Hardener by weight",
    "work_time": "3-5 minutes @ 70 degrees F",
    "cure_time": "13 minutes average",
    "problems": [
      "crack"
    ]
  },
  "superior gold gv-9 thicker knife grade adhesives": {
    "type": "adhesive",
    "subtype": "Acrylic Vinyl Ester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "rodding",
      "seaming",
      "mitering",
      "laminating"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble"
    ],
    "viscosity": "Thick Knife Grade (Gv 9 = Thicker)",
    "colors": [
      "clear/translucent"
    ],
    "warnings": [
      "Indoor use only.",
      "Thicker than GV-5 for vertical applications."
    ],
    "disc": false,
    "mix_ratio": "1%-2% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-25 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior gold gv-1 flowing adhesive for stone laminating and seaming": {
    "type": "adhesive",
    "subtype": "Acrylic Vinyl Ester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "rodding",
      "seaming",
      "laminating"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble"
    ],
    "viscosity": "Flowing",
    "colors": [
      "clear/translucent"
    ],
    "warnings": [
      "Indoor use only.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1%-2% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-25 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior v-max sv-1 flowing adhesive for outdoor stone fabrication": {
    "type": "adhesive",
    "subtype": "Vinyl Ester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior and exterior"
    ],
    "app": [
      "rodding",
      "seaming",
      "laminating"
    ],
    "mat": [
      "engineered",
      "granite",
      "marble"
    ],
    "viscosity": "Flowing",
    "colors": [
      "clear/translucent"
    ],
    "warnings": [
      "Suitable for exterior use.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1%-2% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior pearl flowing adhesive for marble and natural stone seaming": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "laminating"
    ],
    "mat": [
      "limestone",
      "marble",
      "granite"
    ],
    "viscosity": "Flowing",
    "colors": [
      "transparent/pearl"
    ],
    "warnings": [
      "Indoor use only.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior travertine filler polyester adhesive": {
    "type": "filler",
    "subtype": "Polyester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "repair"
    ],
    "mat": [
      "travertine",
      "marble",
      "granite"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "travertine-matched (ivory/buff)"
    ],
    "warnings": [
      "Indoor use only.",
      "Specifically formulated for travertine hole filling.",
      "May yellow on light-colored marble over time."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior black polyester knife grade adhesive": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "granite",
      "dark stone"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "black"
    ],
    "warnings": [
      "Indoor use only.",
      "Pre-colored black."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior white polyester flowing adhesive": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "repair",
      "laminating"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "viscosity": "Flowing",
    "colors": [
      "white"
    ],
    "warnings": [
      "Indoor use only.",
      "Pre-colored white.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior buff polyester knife grade adhesive": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "travertine",
      "marble",
      "granite"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "buff/beige"
    ],
    "warnings": [
      "Indoor use only.",
      "Pre-colored buff.",
      "May yellow on light-colored marble over time."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior buff polyester flowing adhesive": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "repair",
      "laminating"
    ],
    "mat": [
      "travertine",
      "marble",
      "granite"
    ],
    "viscosity": "Flowing",
    "colors": [
      "buff/beige"
    ],
    "warnings": [
      "Indoor use only.",
      "Pre-colored buff.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior water-clear polyester flowing adhesive": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "repair",
      "laminating"
    ],
    "mat": [
      "marble",
      "granite",
      "white stone"
    ],
    "viscosity": "Flowing",
    "colors": [
      "water-clear"
    ],
    "warnings": [
      "Indoor use only.",
      "Premium clarity for white/light stones.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior polyester transparent flowing adhesives": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "repair",
      "laminating"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "viscosity": "Flowing",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Indoor use only.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior water clear polyester knife grade adhesive": {
    "type": "adhesive",
    "subtype": "Polyester",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "app": [
      "seaming",
      "repair",
      "laminating"
    ],
    "mat": [
      "marble",
      "granite",
      "white stone"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "water-clear"
    ],
    "warnings": [
      "Indoor use only.",
      "Premium clarity for white/light stones.",
      "May yellow on light-colored marble over time."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "4-6 minutes @ 70 degrees F",
    "cure_time": "20-30 minutes @ 70 degrees F",
    "problems": [
      "crack"
    ]
  },
  "superior acrylic penetrating adhesive - quart": {
    "type": "adhesive",
    "subtype": "Acrylic",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "viscosity": "Super Flowing / Penetrating",
    "colors": [],
    "warnings": [
      "Indoor use only.",
      "Very low viscosity - penetrates deep into stone.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1-4% BPO hardener by weight",
    "work_time": "8-12 min",
    "cure_time": "20-30 min",
    "app": [
      "fissures",
      "repair"
    ],
    "problems": [
      "crack"
    ]
  },
  "superior stone cleanser degreaser for granite marble and natural stone": {
    "type": "cleaner",
    "subtype": "Degreaser",
    "vendor": "Superior Stone Products",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": ""
  },
  "superior e-1000 flowing epoxy parts for stone laminating and seaming": {
    "type": "adhesive",
    "subtype": "Epoxy (Two-Part)",
    "vendor": "Superior Stone Products",
    "env": [
      "interior and exterior"
    ],
    "app": [
      "rodding",
      "seaming",
      "laminating"
    ],
    "mat": [
      "engineered",
      "granite"
    ],
    "viscosity": "Flowing (Syrup Consistency)",
    "colors": [
      "extra clear (translucent/colorless)"
    ],
    "warnings": [
      "Suitable for freeze/thaw conditions.",
      "Withstands vibrations and shock loads.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
    "work_time": "5-10 minutes",
    "cure_time": "2-4 hours",
    "problems": [
      "crack"
    ]
  },
  "superior e-1000 gallon flowing epoxy unit": {
    "type": "adhesive",
    "subtype": "Epoxy (Two-Part)",
    "vendor": "Superior Stone Products",
    "env": [
      "interior and exterior"
    ],
    "app": [
      "rodding",
      "seaming",
      "laminating"
    ],
    "mat": [
      "engineered",
      "granite"
    ],
    "viscosity": "Flowing (Syrup Consistency)",
    "colors": [
      "extra clear (translucent/colorless)"
    ],
    "warnings": [
      "Suitable for freeze/thaw conditions.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
    "work_time": "5-10 minutes",
    "cure_time": "2-4 hours",
    "problems": [
      "crack"
    ]
  },
  "superior e-1000 quart flowing epoxy unit": {
    "type": "adhesive",
    "subtype": "Epoxy (Two-Part)",
    "vendor": "Superior Stone Products",
    "env": [
      "interior and exterior"
    ],
    "app": [
      "rodding",
      "seaming",
      "laminating"
    ],
    "mat": [
      "engineered",
      "granite"
    ],
    "viscosity": "Flowing (Syrup Consistency)",
    "colors": [
      "extra clear (translucent/colorless)"
    ],
    "warnings": [
      "Suitable for freeze/thaw conditions.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "disc": false,
    "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
    "work_time": "5-10 minutes",
    "cure_time": "2-4 hours",
    "problems": [
      "crack"
    ]
  },
  "superior e-1010 gallon knife grade epoxy unit": {
    "type": "adhesive",
    "subtype": "Epoxy (Two-Part)",
    "vendor": "Superior Stone Products",
    "env": [
      "interior and exterior"
    ],
    "app": [
      "rodding",
      "seaming",
      "mitering",
      "laminating",
      "repair"
    ],
    "mat": [
      "engineered",
      "fiberglass",
      "concrete",
      "metals",
      "granite"
    ],
    "viscosity": "Knife Grade (Paste)",
    "colors": [
      "extra clear (translucent/colorless)"
    ],
    "warnings": [
      "Suitable for freeze/thaw conditions.",
      "No sag on vertical surfaces."
    ],
    "disc": false,
    "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
    "work_time": "5-10 minutes",
    "cure_time": "2-4 hours",
    "problems": [
      "crack"
    ]
  },
  "superior e-1010 knife grade epoxy parts for stone vertical bonding": {
    "type": "adhesive",
    "subtype": "Epoxy (Two-Part)",
    "vendor": "Superior Stone Products",
    "env": [
      "interior and exterior"
    ],
    "app": [
      "rodding",
      "seaming",
      "mitering",
      "laminating",
      "repair"
    ],
    "mat": [
      "engineered",
      "fiberglass",
      "concrete",
      "metals",
      "granite"
    ],
    "viscosity": "Knife Grade (Paste)",
    "colors": [
      "extra clear (translucent/colorless)"
    ],
    "warnings": [
      "Suitable for freeze/thaw conditions.",
      "No sag on vertical surfaces."
    ],
    "disc": false,
    "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
    "work_time": "5-10 minutes",
    "cure_time": "2-4 hours",
    "problems": [
      "crack"
    ]
  },
  "superior e-1010 quart knife grade epoxy unit": {
    "type": "adhesive",
    "subtype": "Epoxy (Two-Part)",
    "vendor": "Superior Stone Products",
    "env": [
      "interior and exterior"
    ],
    "app": [
      "rodding",
      "seaming",
      "mitering",
      "laminating",
      "repair"
    ],
    "mat": [
      "engineered",
      "fiberglass",
      "concrete",
      "metals",
      "granite"
    ],
    "viscosity": "Knife Grade (Paste)",
    "colors": [
      "extra clear (translucent/colorless)"
    ],
    "warnings": [
      "Suitable for freeze/thaw conditions.",
      "No sag on vertical surfaces."
    ],
    "disc": false,
    "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
    "work_time": "5-10 minutes",
    "cure_time": "2-4 hours",
    "problems": [
      "crack"
    ]
  },
  "superior e-1500s knife grade gallon epoxy unit": {
    "type": "adhesive",
    "subtype": "Epoxy (Two-Part)",
    "vendor": "Superior Stone Products",
    "env": [
      "interior and exterior"
    ],
    "app": [
      "rodding",
      "mitering",
      "seaming",
      "laminating",
      "repair"
    ],
    "mat": [
      "engineered",
      "granite"
    ],
    "viscosity": "Knife Grade",
    "colors": [
      "translucent"
    ],
    "warnings": [
      "For professional use only."
    ],
    "disc": false,
    "mix_ratio": "per manufacturer instructions",
    "work_time": "30-60 min",
    "cure_time": "4-24 hr",
    "problems": [
      "crack"
    ]
  },
  "superior gold evolution ext 250ml cartridges": {
    "type": "adhesive",
    "subtype": "Modified Acrylic Vinyl Ester (CArtridge Format)",
    "vendor": "Superior Stone Products",
    "env": [
      "interior and exterior"
    ],
    "app": [
      "rodding",
      "seaming",
      "repair",
      "mitering"
    ],
    "mat": [
      "engineered",
      "granite",
      "sintered",
      "quartz",
      "porcelain"
    ],
    "viscosity": "Knife Grade (Cartridge Dispensed)",
    "colors": [
      "various - color-matched cartridges"
    ],
    "warnings": [
      "Requires cartridge dispensing gun and mixing nozzle."
    ],
    "disc": false,
    "mix_ratio": "pre-metered dual cartridge",
    "work_time": "5-8 min",
    "cure_time": "20-30 min",
    "problems": [
      "crack"
    ]
  },
  "superior lightning instant color enhancer for engineered quartz": {
    "type": "enhancer",
    "subtype": "Color Enhancer",
    "vendor": "Superior Stone Products",
    "env": [
      "interior"
    ],
    "mat": [
      "engineered"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "Liquid",
    "colors": [],
    "warnings": [
      "For engineered quartz only - not natural stone."
    ],
    "disc": false,
    "mix_ratio": "N/A - ready to use",
    "work_time": "",
    "cure_time": "",
    "app": [
      "enhancing"
    ]
  },
  "bellinzoni idea stonager antistain color intensifier 1 l": {
    "type": "enhancer",
    "subtype": "Penetrating, Solvent-Based, Color Intensifier",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "mat": [
      "marble",
      "engineered",
      "concrete",
      "granite",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Surface must be dry and clean before application.",
      "Remove existing stains and mold first.",
      "Wait 24 hours before foot traffic.",
      "For unpolished/textured surfaces.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true,
    "app": [
      "enhancing"
    ]
  },
  "bellinzoni mangiamacchia spot remover 250 ml": {
    "type": "stain-remover",
    "subtype": "Poultice, Paste",
    "vendor": "Bellinzoni",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "concrete"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Apply thick layer over stain.",
      "Cover with plastic wrap.",
      "Allow 12-24 hours to draw out stain.",
      "May require repeat applications."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-refresh top gentle cleaner for kitchen and bathroom countertops 750 ml": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Spray, Gentle",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "countertops",
      "engineered"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "For daily maintenance use.",
      "Gentle formula safe for natural stone."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni idea dark antistain deep enhancer protective agent 1 l": {
    "type": "enhancer",
    "subtype": "Penetrating, Solvent-Based, Nano-Tech, Deep Color Enhancer",
    "vendor": "Bellinzoni",
    "env": [
      "interior",
      "exterior"
    ],
    "mat": [
      "marble",
      "absorbent stone",
      "rough stone",
      "leather finish stone",
      "concrete",
      "dark colored stone",
      "granite",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Extra dark effect - changes appearance significantly.",
      "Apply between 10-30C.",
      "Turn off underfloor heating before application.",
      "PFAS-free.",
      "Remove excess after 10-15 minutes.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true,
    "app": [
      "enhancing"
    ]
  },
  "bellinzoni b-listo maintenance cream 250 ml": {
    "type": "polish",
    "subtype": "Cream, Solvent-Free",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "marble",
      "granite",
      "countertops",
      "tables",
      "quartz resin",
      "window sills",
      "travertine"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Apply with cotton cloth in circular motions.",
      "Allow 10-15 minutes drying before buffing.",
      "Surface must be clean and dry."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-rust remover gel for stone & tile surfaces": {
    "type": "stain-remover",
    "subtype": "Gel, Rust-Specific",
    "vendor": "Bellinzoni",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "concrete",
      "ceramic tile",
      "granite",
      "porcelain"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Gel formula for vertical and horizontal surfaces.",
      "Test on inconspicuous area first."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni idea gold antistain protective agent natural color 1 l": {
    "type": "sealer",
    "subtype": "Penetrating, Nano-Tech, Natural Effect",
    "vendor": "Bellinzoni",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Does not alter natural color - pearl effect.",
      "UV resistant.",
      "Allows stone to breathe.",
      "Apply between 10-30C.",
      "Turn off underfloor heating before application."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni idea quarzo color enhancer protective agent 1 l": {
    "type": "enhancer",
    "subtype": "Penetrating, Solvent-Based, Nano-Tech",
    "vendor": "Bellinzoni",
    "env": [
      "interior",
      "exterior"
    ],
    "mat": [
      "engineered",
      "marble",
      "synthetic stone",
      "porcelain",
      "quartz resin"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "PFAS-free.",
      "Apply between 10-30C.",
      "Turn off underfloor heating first.",
      "UV resistant.",
      "Surface must be free of dirt and salt deposits.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true,
    "app": [
      "enhancing"
    ]
  },
  "bellinzoni idea tropical antistain color intensifier 1 l": {
    "type": "enhancer",
    "subtype": "Penetrating, Solvent-Based, Color Intensifier",
    "vendor": "Bellinzoni",
    "env": [
      "interior",
      "exterior"
    ],
    "mat": [
      "granite"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "For professional use only.",
      "Test before application.",
      "Wait 24 hours before foot traffic.",
      "UV resistant.",
      "Breathable formula."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "app": [
      "enhancing"
    ]
  },
  "bellinzoni wall clean spray paint, marker and grafitti remover 1 l": {
    "type": "cleaner",
    "subtype": "Gel, Voc-Free, Graffiti Remover",
    "vendor": "Bellinzoni",
    "env": [
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "glass",
      "granite",
      "aluminum",
      "metal"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "High (Gel, Non Drip)",
    "colors": [],
    "warnings": [
      "VOC-free.",
      "Non-drip gel for vertical surfaces.",
      "Minimum 10 minutes dwell time.",
      "Test on painted or plastic surfaces first.",
      "No acids, alkalines, oxidants, or reducers."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni eureka marble polishing gel 1 l": {
    "type": "polish",
    "subtype": "Gel, Lead-Free",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "limestone",
      "marble",
      "terrazzo",
      "calcareous stone",
      "travertine"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Use with buffing machine or grinder at 800-1500 rpm.",
      "Optimal speed 1000 rpm.",
      "Surface must be polished above grit 400.",
      "Lead-free.",
      "Wash floor with alkaline solution after use."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni quartz care system kit for engineered quartz surfaces": {
    "type": "kit",
    "subtype": "CAre System, Multi-Product",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "mat": [
      "quartz resin",
      "engineered",
      "countertops"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Specifically formulated for engineered quartz.",
      "Follow kit instructions for each product."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "problems": [
      "general-cleaning"
    ],
    "app": [
      "cleaning"
    ]
  },
  "bellinzoni b-27 exxtra concentrated acidic based detergent 1 l": {
    "type": "cleaner",
    "subtype": "Concentrated, Acid-Based, Heavy-Duty",
    "vendor": "Bellinzoni",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "ceramic",
      "granite",
      "acid resistant stone",
      "cement",
      "sintered",
      "porcelain",
      "engineered",
      "concrete"
    ],
    "problems": [
      "epoxy-haze",
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "ACID-BASED - DO NOT use on marble, limestone, travertine, or calcium-based stones.",
      "For acid-resistant surfaces only.",
      "Concentrated - requires dilution."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-3 action doccia limescale and heavy water deposits remover 750 ml": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Spray, Limescale Remover",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "glass",
      "chrome fixtures",
      "bathroom tile",
      "shower surfaces"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Do not use on marble or acid-sensitive stone.",
      "For bathroom/shower use."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-3 action inox greasy fingerprint and smudge remover 750 ml": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Spray, Stainless-Steel Specific",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "metal appliances",
      "inox surfaces",
      "stainless steel"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "For stainless steel surfaces only."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-3 action top 3 in 1 formula; cleans, protects and polishes 750 ml": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Spray, 3-In-1",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "countertops",
      "travertine"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "3-in-1: cleans, protects, and polishes in one step."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-3 action wood clean, protect and polish for wood surfaces 750 ml": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Spray, Wood-Specific",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "wood furniture",
      "wood floors",
      "wood surfaces"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "For wood surfaces only - not for stone."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-clean inox multi surface cleaner for all stainless-steel surfaces 750 ml": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Spray, Stainless-Steel Specific",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "inox",
      "metal surfaces",
      "stainless steel"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "For stainless steel surfaces."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-dural brill surface strengthening polish 1 l": {
    "type": "polish",
    "subtype": "Liquid, Surface Strengthener",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "marble",
      "granite",
      "terrazzo",
      "travertine"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Professional-grade polish.",
      "Apply with buffing machine for best results."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-gtx grout joint cleaner 750 ml": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Spray, Grout-Specific",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "cement grout",
      "tile grout joints"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "For cementitious grout joints.",
      "Test on inconspicuous area first."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-grayout grey stain remover for wood surfaces 750 ml": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Wood-Specific, Stain Remover",
    "vendor": "Bellinzoni",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "wood surfaces",
      "outdoor wood",
      "grey weathered wood"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "For wood surfaces only - not for stone.",
      "Removes grey patina from weathered wood."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-lem3 exxtra mg foaming detergent for floors 1 l": {
    "type": "cleaner",
    "subtype": "Concentrated, Foaming, Neutral PH",
    "vendor": "Bellinzoni",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "ceramic",
      "terracotta",
      "concrete",
      "granite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Concentrated - requires dilution.",
      "Neutral pH safe for all stone types.",
      "Foaming formula."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-oil 4 cleaner foaming detergent for oil treated parquet and wood surfaces 1 l": {
    "type": "cleaner",
    "subtype": "Foaming, Wood-Specific",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "oil treated parquet",
      "wood floors",
      "oil treated wood"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Specifically for oil-treated wood surfaces.",
      "Not for stone surfaces."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-pro joint protection for cementitous based joints from oil and water-based stains 750 ml": {
    "type": "sealer",
    "subtype": "Grout Sealer, Spray",
    "vendor": "Bellinzoni",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "cementitious joints",
      "cement grout"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "For cementitious grout only, not epoxy grout."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-remoxy cleaning gel for epoxy residues 1 kg": {
    "type": "cleaner",
    "subtype": "Gel, Epoxy Remover",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "glass mosaic",
      "marble",
      "quartzite",
      "ceramic tile",
      "granite",
      "sintered",
      "porcelain",
      "engineered",
      "concrete"
    ],
    "problems": [
      "epoxy-haze",
      "general-cleaning"
    ],
    "viscosity": "High (Gel)",
    "colors": [],
    "warnings": [
      "For removing cured epoxy residue.",
      "Apply and allow dwell time.",
      "Do not use on absorbent untreated stone without testing."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-sanychlor mold and mildew stain remover 750 ml": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Spray, Sanitizing",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "grout",
      "granite",
      "tile",
      "marble"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Contains chlorine-based active ingredients.",
      "Test on inconspicuous area first.",
      "Rinse after use."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-sanyfloor ph neutral sanitizing detergent 1 l": {
    "type": "cleaner",
    "subtype": "Concentrated, PH-Neutral, Sanitizing",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "ceramic tile",
      "granite",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "PH neutral - safe for natural stone.",
      "Concentrated - requires dilution."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-super cleaner degreasing solvent cleaner 1 l": {
    "type": "cleaner",
    "subtype": "Solvent-Based, Degreaser",
    "vendor": "Bellinzoni",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "concrete"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Solvent-based - use in well-ventilated area.",
      "For heavy-duty degreasing."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-top restorer polishing cream 250 ml": {
    "type": "polish",
    "subtype": "Cream, Restoration",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "marble",
      "granite",
      "countertops",
      "travertine"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Apply with soft cloth in circular motions.",
      "Buff to shine after drying."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-wash & polish 2-in-1 detergent and polish for hard floors 1 l": {
    "type": "cleaner",
    "subtype": "Concentrated, 2-In-1, Cleaner-Polish",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "terrazzo",
      "travertine"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "2-in-1: cleans and polishes in one step.",
      "For hard floors only."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b-xtreme hd cleaner ck high-concentrate cleaner for terracotta, clinker, glazed ceramic and quarry tile 1l": {
    "type": "cleaner",
    "subtype": "Concentrated, Heavy-Duty",
    "vendor": "Bellinzoni",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "glazed ceramic",
      "terracotta",
      "clinker",
      "quarry tile"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "High-concentrate - dilute before use.",
      "Specific for terracotta, clinker, and quarry tile."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni b- lem3 exxtra wd neutral detergent 1l": {
    "type": "cleaner",
    "subtype": "Concentrated, Neutral PH",
    "vendor": "Bellinzoni",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "ceramic",
      "terracotta",
      "gres",
      "concrete",
      "granite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Neutral pH - safe for all stone types.",
      "Concentrated - requires dilution."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni epox premium set (a and b) epoxy mastic for gluing, jointing and filling": {
    "type": "adhesive",
    "subtype": "Two-Component Epoxy, 2:1 Ratio",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "rodding",
      "repair"
    ],
    "mat": [
      "marble",
      "glass",
      "terrazzo",
      "concrete",
      "stone honeycomb panels",
      "granite",
      "agglomerates",
      "plexiglass"
    ],
    "viscosity": "Paste (Knife Grade)",
    "colors": [
      "colorless/transparent"
    ],
    "warnings": [
      "Mix 2:1 ratio.",
      "Workable 20-30 minutes at 20C.",
      "Movable after 6-8 hours.",
      "Polishable after 14-16 hours.",
      "Max stability 7 days.",
      "Do not apply below 10C.",
      "Very low yellowing."
    ],
    "disc": false,
    "mix_ratio": "2:1",
    "work_time": "20-30",
    "cure_time": "480",
    "problems": [
      "crack"
    ]
  },
  "bellinzoni eureka granite polishing gel for granite 1 l": {
    "type": "polish",
    "subtype": "Gel, Lead-Free",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "granite",
      "gres",
      "hard silica containing stone"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Use with orbital sander at 800-1500 rpm.",
      "Optimal 1000 rpm.",
      "Works on surfaces from grit 220+.",
      "Lead-free.",
      "Alternative to tin oxide."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "bellinzoni eureka quartz resin polishing gel 1 l": {
    "type": "polish",
    "subtype": "Gel, Engineered-Stone Specific",
    "vendor": "Bellinzoni",
    "env": [
      "interior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "engineered",
      "silestone",
      "sm quartz",
      "okite",
      "quartz resin"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Use with orbital sander at 800-1500 rpm.",
      "Optimal 1000 rpm.",
      "For countertops: 10-15g per application."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "fila norust rust stain remover for natural stone and tile": {
    "type": "stain-remover",
    "subtype": "Gel, Non-Acidic, Rust-Specific",
    "vendor": "FILA",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "terrazzo",
      "terracotta",
      "concrete",
      "granite",
      "porcelain"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "Gel",
    "colors": [],
    "warnings": [
      "Non-acidic - safe for marble, limestone, travertine.",
      "Turns purple when reacting with rust.",
      "15-minute dwell time.",
      "Repeat for stubborn stains.",
      "May strip wax from treated surfaces."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "fila deterdek qt. - cement grout haze remover": {
    "type": "cleaner",
    "subtype": "Water-Based, Acidic",
    "vendor": "FILA",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "terracotta",
      "quarry tile",
      "ceramic tile",
      "granite",
      "acid resistant stone",
      "sintered",
      "quartzite",
      "porcelain",
      "engineered",
      "concrete"
    ],
    "problems": [
      "epoxy-haze",
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Do NOT use on marble, limestone, or travertine.",
      "Only for cement-based grouts.",
      "Alternative to muriatic acid.",
      "No harmful fumes."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "fila ps87 1 gallon heavy duty stone and tile cleaner concentrate": {
    "type": "cleaner",
    "subtype": "Water-Based, Alkaline, Concentrated, Degreaser",
    "vendor": "FILA",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "terracotta",
      "unpolished agglomerates",
      "concrete",
      "quarry tile",
      "glazed ceramic",
      "granite",
      "sintered",
      "porcelain",
      "linoleum",
      "pvc"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Do not use on polished marble or polished stone.",
      "Do not use on wood.",
      "Concentrated - dilute 1:5 to 1:20.",
      "Biodegradable."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "fila kitchenkare 24 oz. - kitchen stain remover": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Spray, Kitchen-Specific",
    "vendor": "FILA",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "metal",
      "ceramic tile",
      "plastic",
      "kitchen surfaces",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Spray and wipe application.",
      "Gentle on hands.",
      "Biodegradable.",
      "Pleasantly scented."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "fila groutrenew - grout cleaner & deep stain remover spray": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Spray, Non-Acidic, Grout-Specific",
    "vendor": "FILA",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "cementitious grout",
      "mosaic",
      "ceramic tile",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Non-acidic formula.",
      "Do NOT use on polished marble, travertine, or limestone.",
      "Do NOT use on waxed surfaces.",
      "Causes plastic/polished surfaces to dull.",
      "Biodegradable.",
      "Seal grout after cleaning with GROUT PROOF."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "fila epoxyoff qt. - epoxy grout haze remover": {
    "type": "cleaner",
    "subtype": "Water-Based, Alkaline, Gel",
    "vendor": "FILA",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "sintered",
      "porcelain",
      "engineered",
      "concrete"
    ],
    "problems": [
      "epoxy-haze",
      "general-cleaning"
    ],
    "viscosity": "Gel",
    "colors": [],
    "warnings": [
      "CRITICAL: Do NOT use on marble, granite, quartzite, limestone, travertine, or any natural stone. For porcelain and engineered surfaces ONLY.",
      "Do NOT use on absorbent materials (natural stone, wood, plastic).",
      "Wait 24 hours after grouting before use.",
      "Ensure grout is fully cured.",
      "30-minute action time.",
      "Biodegradable."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "fila showerclean & shine 24 oz. - bathroom soap scum remover": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Spray, Bathroom-Specific",
    "vendor": "FILA",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "glass",
      "shower surfaces",
      "ceramic tile",
      "granite",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "For bathroom and shower surfaces.",
      "Spray and wipe."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "fila refresh & reseal 24 oz. - neutral cleaner & resealer spray": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Spray, Neutral PH, Cleaner + Resealer",
    "vendor": "FILA",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "travertine",
      "marble",
      "limestone",
      "granite",
      "quartz",
      "quartzite"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "No rinsing required.",
      "Spray and wipe with dry cloth.",
      "PFOA and PFOS free.",
      "Food-contact safe.",
      "Biodegradable."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "fila cleanall spray 24 oz. - neutral everyday cleaner": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Spray, Neutral PH",
    "vendor": "FILA",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "wood",
      "ceramic tile",
      "granite",
      "laminate",
      "sintered",
      "porcelain"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "PH neutral - safe for natural stone.",
      "No rinsing needed.",
      "Biodegradable."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "fila - contractor's choice sealer - 1 gallon": {
    "type": "sealer",
    "subtype": "Penetrating, Water-Based, Eco-Friendly",
    "vendor": "FILA Solutions",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "cement grout",
      "granite",
      "concrete",
      "terracotta"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Water-based, VOC-free.",
      "Odorless.",
      "PFOA and PFOS not intentionally added."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "k-bond vivid vinyl ester adhesive knife grade": {
    "type": "adhesive",
    "subtype": "Vinyl Ester, Knife Grade",
    "vendor": "K-Bond",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "rodding",
      "laminating",
      "repair"
    ],
    "mat": [
      "quartzite",
      "engineered",
      "granite",
      "marble"
    ],
    "viscosity": "Knife Grade (Thick Paste)",
    "colors": [
      "clear/colorless"
    ],
    "warnings": [
      "Vinyl ester - superior UV resistance vs polyester.",
      "Better outdoor durability than polyester.",
      "Requires hardener/catalyst."
    ],
    "disc": false,
    "mix_ratio": "1-3% BPO hardener",
    "work_time": "4-6",
    "cure_time": "20-30",
    "problems": [
      "crack"
    ]
  },
  "k-bond polyester stone adhesive transparent paste - quart": {
    "type": "adhesive",
    "subtype": "Polyester, Transparent, Paste",
    "vendor": "K-Bond",
    "env": [
      "interior"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "viscosity": "Paste (Knife Grade)",
    "colors": [
      "transparent"
    ],
    "warnings": [
      "Requires hardener/catalyst (BPO).",
      "Can be tinted with pigments.",
      "Quart size."
    ],
    "disc": false,
    "mix_ratio": "1-3% BPO hardener",
    "work_time": "4-6",
    "cure_time": "30-60",
    "app": [
      "seaming",
      "repair"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ]
  },
  "k-bond - icon colorless knife grade styren free adhesive": {
    "type": "adhesive",
    "subtype": "Styrene-Free, Knife Grade",
    "vendor": "K-Bond",
    "env": [
      "interior"
    ],
    "mat": [
      "engineered",
      "marble",
      "granite",
      "quartz",
      "quartzite"
    ],
    "viscosity": "Knife Grade (Thick Paste)",
    "colors": [
      "colorless"
    ],
    "warnings": [
      "Styrene-free - low odor, better indoor air quality.",
      "Requires hardener/catalyst."
    ],
    "disc": false,
    "mix_ratio": "2-3% BPO hardener",
    "work_time": "5-7",
    "cure_time": "20-30",
    "app": [
      "seaming",
      "repair"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ]
  },
  "k-bond elite stone adhesive knife grade for granite and marble seams": {
    "type": "adhesive",
    "subtype": "Polyester, Knife Grade, Premium",
    "vendor": "K-Bond",
    "env": [
      "interior"
    ],
    "mat": [
      "marble",
      "granite"
    ],
    "viscosity": "Knife Grade (Thick Paste)",
    "colors": [],
    "warnings": [
      "Premium formula for stone seams.",
      "Requires hardener/catalyst."
    ],
    "disc": false,
    "mix_ratio": "1-3% BPO hardener",
    "work_time": "4-6",
    "cure_time": "20-30",
    "app": [
      "seaming",
      "repair"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ]
  },
  "k-bond high performance polyester white paste stone adhesive": {
    "type": "adhesive",
    "subtype": "Polyester, Paste, White",
    "vendor": "K-Bond",
    "env": [
      "interior"
    ],
    "app": [
      "repair"
    ],
    "mat": [
      "marble",
      "granite",
      "light colored stone"
    ],
    "viscosity": "Paste",
    "colors": [
      "white"
    ],
    "warnings": [
      "White color - for light-colored stone.",
      "Requires hardener/catalyst."
    ],
    "disc": false,
    "mix_ratio": "1-3% BPO hardener",
    "work_time": "5-7",
    "cure_time": "30-60",
    "problems": [
      "crack"
    ]
  },
  "k-bond ultimate perormance poly-epoxy knife grade - quart": {
    "type": "adhesive",
    "subtype": "Poly-Epoxy Hybrid, Knife Grade",
    "vendor": "K-Bond",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "rodding",
      "laminating",
      "repair"
    ],
    "mat": [
      "quartzite",
      "engineered",
      "granite",
      "marble"
    ],
    "viscosity": "Knife Grade (Thick Paste)",
    "colors": [],
    "warnings": [
      "Poly-epoxy hybrid - combines polyester speed with epoxy strength.",
      "Quart size.",
      "Requires hardener/catalyst."
    ],
    "disc": false,
    "mix_ratio": "1-3% BPO hardener",
    "work_time": "4-6",
    "cure_time": "25-30",
    "problems": [
      "crack"
    ]
  },
  "kraken bond ultra grab high tack - white construction adhesive 300ml 10.1 fl oz": {
    "type": "adhesive",
    "subtype": "Construction Adhesive, High-Tack, Ms Polymer",
    "vendor": "Kraken Bond",
    "env": [
      "interior",
      "exterior"
    ],
    "mat": [
      "foam",
      "ceramic",
      "wood",
      "metal",
      "stone",
      "concrete",
      "most building materials",
      "pvc"
    ],
    "viscosity": "Paste (Cartridge)",
    "colors": [
      "white"
    ],
    "warnings": [
      "High initial grab - holds without bracing.",
      "Paintable.",
      "Interior and exterior use.",
      "Isocyanate-free."
    ],
    "disc": false,
    "mix_ratio": "N/A (single component)",
    "work_time": "10-15",
    "cure_time": "1440",
    "app": [
      "repair"
    ],
    "problems": [
      "bond-failure",
      "crack"
    ]
  },
  "hot stuff instant glue (thin, medium, thick) - 2 oz": {
    "type": "adhesive",
    "subtype": "Cyanoacrylate (CA) Glue",
    "vendor": "Satellite City",
    "env": [
      "interior",
      "exterior"
    ],
    "mat": [
      "engineered",
      "marble",
      "ceramic",
      "wood",
      "metal",
      "rubber",
      "granite",
      "plastic"
    ],
    "viscosity": "Thin (Water Like, Wicking) / Medium (Honey Like, Gap Filling) / Thick (Gel, Vertical Surfaces)",
    "colors": [
      "clear"
    ],
    "warnings": [
      "Thin: wicks into hairline cracks, 5-second bond.",
      "Medium: fills small gaps, 10-15 second bond.",
      "Thick: fills larger gaps, 30-60 second bond.",
      "Bonds skin instantly - use with care.",
      "Use accelerator for instant full cure.",
      "TEMPORARY BOND ONLY. Do NOT use for permanent seams - use methacrylate or epoxy."
    ],
    "disc": false,
    "mix_ratio": "N/A (single component CA)",
    "work_time": "0",
    "cure_time": "0.08-1",
    "app": [
      "seaming"
    ],
    "problems": [
      "crack"
    ]
  },
  "dry-treat - stain-proof original - premium impregnating sealer - qt": {
    "type": "sealer",
    "subtype": "Penetrating, Water-Based Impregnator",
    "vendor": "Stain-Proof",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "travertine",
      "marble",
      "terracotta",
      "limestone",
      "concrete",
      "slate",
      "brick",
      "granite",
      "sandstone",
      "grout"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Premium impregnating sealer.",
      "Does not alter appearance.",
      "Breathable.",
      "15-year warranty when professionally applied."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "dry-treat - stain-proof plus - premium countertop/dense impregnating sealer - 16oz": {
    "type": "sealer",
    "subtype": "Penetrating, For Dense/Polished Surfaces",
    "vendor": "Stain-Proof",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "porcelain",
      "engineered",
      "granite",
      "marble"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "For dense, polished, and low-porosity surfaces.",
      "Penetrates where standard sealers cannot.",
      "Does not alter appearance."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "dry-treat - eff-erayza rust remover - safe acid stone & masonry cleaner - qt": {
    "type": "cleaner",
    "subtype": "Acid-Based, Rust Remover, Safe For Stone",
    "vendor": "Stain-Proof",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "grout",
      "granite",
      "concrete",
      "masonry"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Safe acid formula - won't damage polished stone when used as directed.",
      "Test first.",
      "Quart size."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "stain-proof porcelain & quartz sealer - 1 quart (formerly porcelain plus)": {
    "type": "sealer",
    "subtype": "Penetrating, For Ultra-Dense Surfaces",
    "vendor": "Stain-Proof",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "porcelain",
      "engineered",
      "ultra compact surfaces",
      "sintered"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "For ultra-dense surfaces that resist standard sealers.",
      "Formerly called Porcelain Plus."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "dry-treat - oxy-klenza stain remover - triple action cleaner - 2.2lb": {
    "type": "cleaner",
    "subtype": "Powder, Oxygen-Based, Triple Action",
    "vendor": "Stain-Proof",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "masonry",
      "limestone",
      "concrete",
      "granite",
      "grout"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Oxygen-based - safe for natural stone.",
      "Mix with water to form paste/solution.",
      "Triple action: cleans, deodorizes, whitens."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "miracle sealants stone polish color and gloss enhancer (quart)": {
    "type": "enhancer",
    "subtype": "Topical Polish, Color Enhancer",
    "vendor": "Miracle Sealants (Rust-Oleum)",
    "env": [
      "interior"
    ],
    "app": [
      "enhancing"
    ],
    "mat": [
      "marble",
      "engineered",
      "concrete",
      "granite",
      "sintered",
      "porcelain",
      "travertine"
    ],
    "problems": [
      "fading"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Topical product - not a penetrating sealer.",
      "Reapply as needed for maintenance.",
      "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "not_for_restoration": true
  },
  "miracle sealants 511qt6 511 impregnator sealer, quart, clear (new version, improved)": {
    "type": "sealer",
    "subtype": "Penetrating Impregnator",
    "vendor": "Miracle Sealants (Rust-Oleum)",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "travertine",
      "marble",
      "terrazzo",
      "limestone",
      "concrete",
      "slate",
      "ceramic tile",
      "granite",
      "quartz",
      "porcelain",
      "grout"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Invisible barrier - does not change surface appearance.",
      "Dry to touch 1-3 hours.",
      "Full cure 72 hours.",
      "Available in water-based and oil-based versions."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "miracle sealants plusgal4 511 porous plus sealer, gallon, yellow": {
    "type": "sealer",
    "subtype": "Penetrating, Solvent-Based, For Porous Surfaces",
    "vendor": "Miracle Sealants (Rust-Oleum)",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "travertine",
      "marble",
      "limestone",
      "slate",
      "granite",
      "quartzite",
      "grout"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Solvent-based: VOC <750 g/L.",
      "For porous surfaces.",
      "Will not alter natural look.",
      "Not a surface coating."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "miracle sealants coukl32oz6 spray counter kleen, 32 ounce, 32 fl oz": {
    "type": "cleaner",
    "subtype": "Ready-To-Use, Spray, PH-Neutral, Daily",
    "vendor": "Miracle Sealants (Rust-Oleum)",
    "env": [
      "interior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "engineered",
      "granite",
      "backsplash",
      "quartz",
      "tile"
    ],
    "problems": [
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "PH neutral - acid-free.",
      "No rinsing required.",
      "Streak-free.",
      "Safe for sealed and unsealed stone."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "crown acetone solvent cleaner 1 gallon for stone fabrication": {
    "type": "solvent",
    "subtype": "Pure Acetone",
    "vendor": "Crown",
    "env": [
      "interior",
      "exterior"
    ],
    "mat": [
      "glass",
      "marble",
      "granite",
      "metal"
    ],
    "viscosity": "Liquid (Water Like)",
    "colors": [],
    "warnings": [
      "Highly flammable.",
      "Use in well-ventilated area.",
      "Avoid contact with skin and eyes.",
      "Keep away from ignition sources.",
      "Not for use on plastic, rubber, or painted surfaces."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "app": [
      "cleaning"
    ],
    "problems": [
      "general-cleaning"
    ]
  },
  "crown denatured alcohol 1 gallon (3.78 l)": {
    "type": "solvent",
    "subtype": "Denatured Alcohol (Ethanol)",
    "vendor": "Crown",
    "env": [
      "interior",
      "exterior"
    ],
    "mat": [
      "glass",
      "marble",
      "granite",
      "metal"
    ],
    "viscosity": "Liquid (Water Like)",
    "colors": [],
    "warnings": [
      "Flammable.",
      "Use in well-ventilated area.",
      "Evaporates quickly leaving no residue.",
      "Good for pre-sealer surface prep."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": "",
    "app": [
      "cleaning"
    ],
    "problems": [
      "general-cleaning"
    ]
  },
  "icr sprint l17 anti-drop solvent base sealer": {
    "type": "sealer",
    "subtype": "Penetrating, Solvent-Based, Anti-Drip",
    "vendor": "ICR",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "sealing"
    ],
    "mat": [
      "marble",
      "granite",
      "concrete"
    ],
    "problems": [
      "water-damage"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "Solvent-based.",
      "Anti-drip formula for vertical surfaces.",
      "Italian manufacturer."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "italian craftsman stone polish for granite and marble surfaces": {
    "type": "polish",
    "subtype": "Topical, Spray Or Liquid",
    "vendor": "Italian Craftsman",
    "env": [
      "interior"
    ],
    "app": [
      "restoration"
    ],
    "mat": [
      "marble",
      "granite",
      "countertops",
      "travertine"
    ],
    "problems": [
      "fading",
      "general-cleaning"
    ],
    "viscosity": "",
    "colors": [],
    "warnings": [
      "For maintenance polishing, not restoration.",
      "Spray and wipe application."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  },
  "rust stain remover (rsr-2000) rust stain remover in gel form": {
    "type": "stain-remover",
    "subtype": "Gel, Rust-Specific",
    "vendor": "Alpha Professional Tools",
    "env": [
      "interior",
      "exterior"
    ],
    "app": [
      "cleaning"
    ],
    "mat": [
      "marble",
      "granite",
      "tile",
      "concrete"
    ],
    "problems": [
      "stain"
    ],
    "viscosity": "Gel",
    "colors": [],
    "warnings": [
      "Gel formula stays in place on vertical surfaces.",
      "Apply and allow dwell time.",
      "Rinse thoroughly after use."
    ],
    "disc": false,
    "mix_ratio": "",
    "work_time": "",
    "cure_time": ""
  }
};
